var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g3, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g4, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _g5, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _g6, _path86, _path87, _g7, _path88, _path89, _path90, _g8, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _g9, _path122, _g0, _path123, _g1, _path124, _path125, _g10, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _g11, _path150, _path151, _path152, _path153, _path154, _path155, _polygon, _path156, _path157, _path158, _path159, _path160, _path161, _rect, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDc21(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 449.46 462.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-10"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-10-2",
    "data-name": "freepik--floor--inject-10",
    cx: 224.73,
    cy: 337.48,
    rx: 224.23,
    ry: 124.15,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-10",
    d: "M451.69,343.15l-125,72.2a3.69,3.69,0,0,1-3.36,0l-180.22-104a1,1,0,0,1,0-1.94l125-72.2a3.69,3.69,0,0,1,3.36,0l180.22,104a1,1,0,0,1,0,1.94Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-10-2",
    "data-name": "freepik--shadow--inject-10",
    cx: 136.1,
    cy: 387.51,
    rx: 75.08,
    ry: 43.35,
    fill: "none",
    stroke: "#e6e6e6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-10-3",
    "data-name": "freepik--shadow--inject-10",
    cx: 227.52,
    cy: 337.25,
    rx: 59.1,
    ry: 34.12,
    fill: "none",
    stroke: "#e6e6e6",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-10-4",
    "data-name": "freepik--shadow--inject-10",
    cx: 358.96,
    cy: 382.99,
    rx: 37.1,
    ry: 21.42,
    fill: "none",
    stroke: "#e6e6e6",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-10-2",
    "data-name": "freepik--desk--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-10"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M329.42,286.36v111a2.47,2.47,0,0,1-1.12,1.94l-2.38,1.37a2.46,2.46,0,0,1-2.24,0l-2.38-1.37a2.47,2.47,0,0,1-1.12-1.94v-111c0-.71.5-1,1.12-.64l2.38,1.37a2.46,2.46,0,0,0,2.24,0l2.38-1.37C328.92,285.36,329.42,285.65,329.42,286.36Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M323.68,400.62l-2.38-1.37a2.47,2.47,0,0,1-1.12-1.94V286.36c0-.71.5-1,1.12-.64l2.38,1.37A2.48,2.48,0,0,1,324.8,289V400C324.8,400.69,324.3,401,323.68,400.62Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M430.93,227.72V338.66a2.47,2.47,0,0,1-1.12,1.94l-2.38,1.4a2.52,2.52,0,0,1-2.24,0l-2.38-1.38a2.47,2.47,0,0,1-1.12-1.94v-111c0-.71.51-1,1.12-.65l2.38,1.38a2.46,2.46,0,0,0,2.24,0l2.38-1.38C430.43,226.72,430.93,227,430.93,227.72Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M425.19,342l-2.38-1.38a2.47,2.47,0,0,1-1.12-1.94v-111c0-.71.51-1,1.12-.65l2.38,1.38a2.47,2.47,0,0,1,1.12,1.94V341.33A.7.7,0,0,1,425.19,342Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192.71,207.47v111a2.47,2.47,0,0,1-1.12,1.94l-2.38,1.37a2.46,2.46,0,0,1-2.24,0l-2.38-1.37a2.47,2.47,0,0,1-1.12-1.94v-111c0-.71.5-1,1.12-.64L187,208.2a2.46,2.46,0,0,0,2.24,0l2.38-1.37C192.21,206.47,192.71,206.76,192.71,207.47Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187,321.73l-2.38-1.37a2.47,2.47,0,0,1-1.12-1.94v-111c0-.71.5-1,1.12-.64L187,208.2a2.47,2.47,0,0,1,1.12,1.94V321.08C188.09,321.8,187.59,322.09,187,321.73Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M453,235.61v-.81a4.5,4.5,0,0,0-2-3.53L272,128a4.51,4.51,0,0,0-4.08,0L157.8,191.6a4.5,4.5,0,0,0-2,3.53V196a4.5,4.5,0,0,0,2,3.53l179,103.26a4.58,4.58,0,0,0,4.08,0L451,239.14A4.5,4.5,0,0,0,453,235.61Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M453,235.61v-.81a4.5,4.5,0,0,0-2-3.53L272,128a4.51,4.51,0,0,0-4.08,0L157.8,191.6a4.5,4.5,0,0,0-2,3.53V196a4.5,4.5,0,0,0,2,3.53l179,103.26a4.58,4.58,0,0,0,4.08,0L451,239.14A4.5,4.5,0,0,0,453,235.61Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M338.82,297.72v5.52a4.23,4.23,0,0,0,2-.49L451,239.15a4.5,4.5,0,0,0,2-3.53v-.82a4.51,4.51,0,0,0-1.66-3.26c.73.63.61,1.5-.38,2.09l-110.12,63.6A4.19,4.19,0,0,1,338.82,297.72Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M338.82,297.72v5.52a4.23,4.23,0,0,0,2-.49L451,239.15a4.5,4.5,0,0,0,2-3.53v-.82a4.51,4.51,0,0,0-1.66-3.26c.73.63.61,1.5-.38,2.09l-110.12,63.6A4.19,4.19,0,0,1,338.82,297.72Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M451,233.62,340.86,297.23a4.51,4.51,0,0,1-4.08,0L157.77,194a1.24,1.24,0,0,1-.78-1.57,1.21,1.21,0,0,1,.78-.78L267.89,128a4.51,4.51,0,0,1,4.08,0L451,231.27a1.24,1.24,0,0,1,.78,1.57A1.21,1.21,0,0,1,451,233.62Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M451,233.62,340.86,297.23a4.51,4.51,0,0,1-4.08,0L157.77,194a1.24,1.24,0,0,1-.78-1.57,1.21,1.21,0,0,1,.78-.78L267.89,128a4.51,4.51,0,0,1,4.08,0L451,231.27a1.24,1.24,0,0,1,.78,1.57A1.21,1.21,0,0,1,451,233.62Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-10-5",
    "data-name": "freepik--shadow--inject-10",
    d: "M325.29,232.24l-26.09,15.1a3.22,3.22,0,0,1-2.93,0L219.19,202.9a.89.89,0,0,1-.57-1.12.9.9,0,0,1,.57-.57l26.09-15.11a3.26,3.26,0,0,1,2.92,0l77.09,44.45a.9.9,0,0,1,.49,1.17A1,1,0,0,1,325.29,232.24Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-10-2",
    "data-name": "freepik--keyboard--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.77,198.53a1,1,0,0,1,.61-.84l24.51-14.15a3.2,3.2,0,0,1,2.92,0l74.8,43.25a1,1,0,0,1,.6.85v2.57a1,1,0,0,1-.6.84l-24.5,14.15a3.22,3.22,0,0,1-2.93,0L221.38,202a1,1,0,0,1-.61-.84Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.11,242.57l24.5-14.09a.89.89,0,0,0,.57-1.12.9.9,0,0,0-.57-.57l-74.8-43.25a3.2,3.2,0,0,0-2.92,0l-24.51,14.15a.89.89,0,0,0-.57,1.12.9.9,0,0,0,.57.57l74.8,43.18A3.25,3.25,0,0,0,299.11,242.57Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.74,242.91v2.63a3,3,0,0,0,1.37-.34l24.49-14.14a1,1,0,0,0,.61-.85v-2.58a1,1,0,0,1-.61.85l-24.49,14.09A3,3,0,0,1,297.74,242.91Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.31,198.72h0l2.42-1.4,3.29,1.9-2.44,1.45-3.29-1.9Zm3.8-2.19h0l2.43-1.4,2.59,1.49L231.69,198l-2.58-1.49Zm.8,4.85h0l2.43-1.4,2.58,1.49-2.44,1.45-2.58-1.49Zm3-7h0l2.43-1.4,4.17,2.42-2.44,1.44-4.17-2.41Zm.09,4.44h0l2.42-1.41,2.06,1.19-2.43,1.4L233,198.79Zm.8,4.84h0l2.42-1.4,2.59,1.49-2.45,1.45-2.58-1.49Zm2.56-2.9h0l2.42-1.4,2,1.19L238.34,202l-2-1.19Zm.34-8.58h0l2.43-1.4,3.29,1.9L240,194.06l-3.29-1.9Zm1,13.73h0l2.42-1.4,18.68,10.78-2.44,1.45L237.68,206Zm.7-8.37h0l2.42-1.4,2,1.19-2.44,1.44-2-1.18Zm1.33,5.16h0l2.42-1.4,2,1.19-2.44,1.45-2-1.19Zm.77-12.7h0l2.42-1.4,2.06,1.19-2.44,1.44-2-1.23Zm.8,4.85h0l2.42-1.4,2.06,1.18L243.36,196l-2.06-1.18Zm.45,4.64h0l2.42-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm1.33,5.16h0l2.42-1.4,2,1.19-2.44,1.45-2-1.19Zm.78-12.71h0l2.42-1.4,2.06,1.19-2.44,1.44-2-1.18Zm.8,4.85h0l2.42-1.4,2.06,1.18L246.7,198l-2-1.18Zm.45,4.64h0l2.42-1.4,2,1.19-2.44,1.44-2-1.18Zm0-14.09h0l2.42-1.4,2.59,1.49-2.45,1.45-2.58-1.49Zm1.33,19.25h0l2.42-1.4,2,1.19-2.44,1.45-2.05-1.19Zm.78-12.71h0l2.42-1.4,2.06,1.19L249.28,195l-2.05-1.18Zm.8,4.85h0l2.42-1.4,2.06,1.18L250.06,200,248,198.7Zm.45,4.64h0l2.42-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm1.33,5.16h0l2.42-1.4,2,1.19-2.44,1.45-2-1.19Zm.66-18.1h0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm.12,5.39h0l2.42-1.4,2.06,1.19L252.63,197l-2-1.18Zm.8,4.85h0l2.42-1.4,2.06,1.18-2.44,1.45-2-1.18Zm.45,4.64h0l2.42-1.4,2,1.19-2.44,1.44-2-1.18Zm1.33,5.16h0L255.6,209l2,1.19-2.44,1.45-2-1.19Zm.66-18.1h0l2.42-1.4,2.06,1.18-2.44,1.45-2-1.18Zm.12,5.39h0l2.42-1.4,2.06,1.19L256,198.91l-2-1.18Zm.8,4.85h0l2.42-1.4,2.06,1.18-2.44,1.45-2-1.18Zm.45,4.64h0l2.43-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm1.33,5.16h0l2.42-1.41,2.05,1.19-2.44,1.45-2.05-1.19Zm.66-18.1h0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm.12,5.39h0l2.43-1.4,2,1.19-2.45,1.44-2-1.18Zm.37,17.76h0l2.43-1.4,2.58,1.49L260.24,219l-2.58-1.49Zm.43-12.91h0l2.42-1.4,2.06,1.18-2.44,1.45-2.05-1.18Zm.45,4.64h0l2.43-1.4,2,1.11-2.44,1.44-2.05-1.18Zm1.33,5.16h0l2.42-1.4,2.06,1.19-2.45,1.45-2.05-1.19Zm.66-18.1h0l2.43-1.4,2,1.15-2.44,1.45-2.05-1.18Zm.12,5.39h0l2.43-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm.8,4.85h0l2.43-1.4,2,1.18-2.44,1.45-2-1.18Zm.1,13.21h0l2.43-1.4,2.58,1.49-2.44,1.45-2.58-1.49Zm.35-8.57h0l2.42-1.4,2,1.19L264,212.28l-2-1.18Zm1.33,5.16h0l2.42-1.4,2.06,1.19-2.45,1.45-2-1.19Zm.78-12.71h0l2.43-1.4,2,1.19L266,204.81l-2-1.26Zm.8,4.85h0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm.45,4.64h0l2.42-1.4,2.05,1.19-2.44,1.44-2-1.3Zm.1-14h0l2.43-1.4,2.05,1.19-2.44,1.45-2-1.31Zm.08,22.91h0l2.43-1.4,2.58,1.49L268,223.41l-2.58-1.49Zm1.15-3.72h0l2.42-1.41,2.06,1.19-2.45,1.45-2-1.19Zm.78-12.71h0l2.42-1.4,2.06,1.19-2.44,1.44-2.05-1.18Zm.8,4.85h0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm.45,4.64h0l2.42-1.4,2.06,1.19-2.45,1.44-2-1.27Zm.1-14h0l2.43-1.4,2,1.19-2.44,1.45-2-1.19Zm.62,23.22h0l2.43-1.41,3.29,1.9-2.44,1.45-3.29-1.9Zm.61-4h0l2.42-1.41,6.48,3.74L276.42,224,270,220.13Zm.78-12.71h0l2.43-1.4,2.05,1.19-2.44,1.44-2-1.18Zm.8,4.85h0L274,211l2,1-2.44,1.45-2.05-1.18ZM272,217h0l2.42-1.4,2.06,1.19L274,218.1l-2-1.18Zm.1-14h0l2.43-1.4,2.05,1.19-2.44,1.45-2.05-1.19Zm2,6.48h0l2.43-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm.55,17.86h0l2.42-1.4,2.06,1.18-2.45,1.45-2-1.18Zm.25-13h0l2.43-1.4,2,1.18L277,215.4l-2-1.18Zm.45,4.64h0l2.42-1.4,1.88,1.08a1.21,1.21,0,0,0,.59.13,1.33,1.33,0,0,0,.62-.13l3.19-1.84,2.4,1.39-6.23,3.64-4.89-2.82Zm.1-14h0l2.43-1.4,2.05,1.19L277.5,206l-2.05-1.19Zm2,6.48h0l2.42-1.4,2.06,1.19-2.44,1.44-2-1.18Zm.55,17.86h0l2.42-1.4,2.06,1.18L280,230.59l-2-1.18Zm.25-13h0l2.43-1.4,2.05,1.18-2.44,1.45-2-1.18Zm2-8.55h0l2.42-1.4,2.06,1.18L282.27,209l-2-1.18Zm.55,5.64h0l2.42-1.4,2.06,1.19-2.44,1.44-2.05-1.18Zm.55,17.86h0l2.43-1.4,2.05,1.18-2.45,1.45-2-1.18Zm.44-4.13h0l2.42-1.4,2.06,1.19-2.45,1.45-2-1.42Zm1.82-17.43h0l2.42-1.4,2.05,1.18L285.63,211l-2.05-1.18Zm.55,5.64h0l2.43-1.4,3.64,2.1-2.44,1.45-3.64-2.1Zm1.26,18.27h0l2.42-1.4,5.42,3.12-2.45,1.45-5.41-3.12Zm.6-12.81h0l2.43-1.4,2.05,1.19-2.44,1.44L286,220.9Zm.95-9.16h0l2.42-1.4,2.05,1.18-2.43,1.2-2-1.18Zm2.25,19.78h0l2.43-1.4,2.05,1.19-2.44,1.45-2.05-1.19Zm.16-8.68h0l2.43-1.4,2,1.19L291.36,224l-2-1.18Zm.44-4.13h0l2.43-1.4,2,1.18-2.44,1.45-2-1.18Zm.51-5h0l2.42-1.4,2,1.18-2.44,1.45-2-1.18Zm1.81,23.91h0l2.42-1.4,2.06,1.18-2.45,1.45-2-1.18Zm.44-4.13h0L295,232l2,1.19-2.44,1.45-2-1.19Zm.16-8.68h0l2.43-1.4,2,1.19L294.77,226l-2-1.18Zm.28,4.54h0l2.43-1.4,2,1.19L295,230.53l-2-1.18Zm.16-8.67h0l2.43-1.4,2,1.18-2.44,1.45-2-1.18Zm1.25-4.6h0l2.42-1.4,2.06,1.18L296.51,217l-2.05-1.18Zm1.07,23.48h0l6.22-3.6,2.05,1.19-6.23,3.64-2.06-1.18Zm.44-4.13h0l2.43-1.4,2.05,1.19L298,236.33l-2-1.19Zm.44-4.14h0l2.43-1.4,2.05,1.19-2.44,1.44-2-1.47Zm.16-8.67h0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm.27,4.54h0l2.43-1.4,2,1.18-2.44,1.45-2-1.18Zm1-9.14h0l2.42-1.4,2.06,1.18-2.44,1.45-2-1.18Zm1.95,15.21h0l2.43-1.4,2.05,1.19-2.44,1.45-2-1.42Zm.43-4.13h0l2.43-1.4,2.05,1.18L302.25,230l-2.05-1.18Zm.44-4.13h0l2.42-1.4,2.06,1.18-2.45,1.45-2-1.18Zm.54-5h0l2.42-1.4,2.06,1.18-2.44,1.45L301.15,220Zm1.95,15.21h0l6.23-3.59,2.05,1.18-6.24,3.65-2-1.19Zm.43-4.13h0l2.43-1.4,2,1.18-2.44,1.45-2.05-1.18Zm.44-4.13h0l2.42-1.4,2.06,1.18L306,227.81l-2-1.18Zm2.23-5.17h0l1-.61,2.06,1.19-1.06.65-2-1.18Zm1.13,7.11h0l2.42-1.4,2.06,1.18L309.37,230l-2-1.18Zm2.23-5.17h0l1-.61,2.06,1.19-1.06.65-2-1.18Zm1.13,7.11h0l2.42-1.4,2.06,1.18L312.73,232l-2-1.18Zm2.23-5.17h0l1-.61,2.06,1.19-1.06.65-2-1.18Zm3.35,1.94h0l1-.61,2.06,1.19-1.06.65-2-1.18Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-10-6",
    "data-name": "freepik--shadow--inject-10",
    points: "360.45 210.29 383.4 197.04 268.64 130.78 245.69 144.03 360.45 210.29",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-10"
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M320.59,213.6l-16.38-9.48c-1.69-1-2.54-2.25-2.54-3.53v-2.28l15.42-8.75a3.62,3.62,0,0,0,1.63-2.83v-20.2l28.62,16.54v20.2a3.62,3.62,0,0,1-1.63,2.83l-12.88,7.5A13.54,13.54,0,0,1,320.59,213.6Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M340.47,206.85v2.27l5.24-3a3.62,3.62,0,0,0,1.63-2.83v-20.2l-5.45-3.15c-.11,1.39-.24,2.82-.35,4.21l3.82,2.22v15.78a3.55,3.55,0,0,1-1.63,2.83Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M345.36,202.13a3.62,3.62,0,0,1-1.63,2.83l-10.9,6.36a13.54,13.54,0,0,1-12.24,0l-16.39-9.48c-3.38-1.94-3.38-5.11,0-7.06l10.91-6.36a3.6,3.6,0,0,0,1.63-2.82V169.81l28.62,16.54Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M311.79,190.34h0l3.32-1.92a3.6,3.6,0,0,0,1.63-2.82V169.81l28.62,16.54v15.78a3.62,3.62,0,0,1-1.63,2.83l-3.26,1.89Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M301.67,198.31v2.28c0,1.28.85,2.55,2.53,3.53l16.39,9.47a12.27,12.27,0,0,0,5.84,1.45v-2.27a12.27,12.27,0,0,1-5.84-1.45l-16.39-9.48C302.52,200.87,301.67,199.59,301.67,198.31Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M391.32,223.93a4.36,4.36,0,0,1-3.95-.07L276.68,160a4.5,4.5,0,0,1-2-3.53V59.54a3.83,3.83,0,0,1,5.87-3.39l110.68,63.91a4.5,4.5,0,0,1,2,3.53v96.88A4.38,4.38,0,0,1,391.32,223.93Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M387.37,223.85,276.68,160a4.5,4.5,0,0,1-2-3.53V59.53c0-1.3.91-1.82,2-1.17l110.69,63.9a4.5,4.5,0,0,1,2,3.53v96.89C389.41,224,388.49,224.5,387.37,223.85Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M387.67,224.26a3.81,3.81,0,0,0,5.56-3.54v-10.9L389.41,212v10.9C389.41,224.12,388.66,224.65,387.67,224.26Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M389.41,212v10.9c0,1.3-.92,1.83-2,1.18L276.68,160.2a4.5,4.5,0,0,1-2-3.53v-10.9Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M385.58,203.74V127.06a2.72,2.72,0,0,0-1.22-2.12L279.69,64.52c-.67-.39-1.22-.08-1.22.7V141.9a2.69,2.69,0,0,0,1.22,2.12l104.67,60.43C385,204.84,385.58,204.52,385.58,203.74Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385.58,203.74V127.06a2.72,2.72,0,0,0-1.22-2.12L279.69,64.52c-.67-.39-1.22-.08-1.22.7V141.9a2.69,2.69,0,0,0,1.22,2.12l104.67,60.43C385,204.84,385.58,204.52,385.58,203.74Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M332,183.07a4.25,4.25,0,0,1,1.91,3.31c0,1.22-.86,1.72-1.91,1.11a4.24,4.24,0,0,1-1.92-3.32C330.11,183,331,182.46,332,183.07Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M388.81,123.78a4.4,4.4,0,0,1,.6,2V212l3.82-2.21v-86.2a4.17,4.17,0,0,0-.6-2Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-10-2",
    "data-name": "freepik--window--inject-10"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M292.75,39.53v-.18h0a.49.49,0,0,1,0-.17.8.8,0,0,1,.11-.25.21.21,0,0,1,.06-.1l.06-.07a.8.8,0,0,1,.13-.13h0a1,1,0,0,1,.17-.1,1.42,1.42,0,0,1,1.31.17l129.18,74.54a4.37,4.37,0,0,1,2,3.39v93.49h0v.43a1.33,1.33,0,0,1-.7,1.17l-.09.06-.1.06h-.42a1.29,1.29,0,0,1-.64-.19h0L422,210.6,294.69,137.12a4.34,4.34,0,0,1-1.95-3.38v-94C292.74,39.69,292.75,39.61,292.75,39.53Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M293.38,38.48a1.42,1.42,0,0,1,1.31.17l129.18,74.54a4.37,4.37,0,0,1,1.95,3.39V123l2.49-1.46v-6.33a4.34,4.34,0,0,0-1.95-3.38L297.18,37.24a1.35,1.35,0,0,0-1.41-.12C295.42,37.34,293.8,38.26,293.38,38.48Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M292.74,39.76c0-1.23.88-1.73,1.95-1.11L423.87,113.2a4.31,4.31,0,0,1,1.95,3.38V123L292.74,46.17Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.69,38.65,423.87,113.2a4,4,0,0,1,1.37,1.44l2.48-1.43a3.81,3.81,0,0,0-1.36-1.43L297.19,37.24a1.37,1.37,0,0,0-1.42-.12c-.35.22-2,1.14-2.38,1.36A1.38,1.38,0,0,1,294.69,38.65Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M428.32,121.5v-6.34a4,4,0,0,0-.59-2l-2.49,1.43a3.8,3.8,0,0,1,.59,1.94V123Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M421.42,114.54a2.92,2.92,0,0,1,1.1,2.34c0,.93-.49,1.41-1.1,1.06a2.92,2.92,0,0,1-1.1-2.34C420.32,114.67,420.81,114.19,421.42,114.54Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M417.45,112.25a2.89,2.89,0,0,1,1.1,2.33c0,.94-.49,1.41-1.1,1.06a2.89,2.89,0,0,1-1.1-2.33C416.35,112.37,416.84,111.9,417.45,112.25Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M413.48,110a2.92,2.92,0,0,1,1.1,2.34c0,.93-.49,1.41-1.1,1.06a2.92,2.92,0,0,1-1.1-2.34C412.38,110.07,412.87,109.6,413.48,110Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M425.12,211.69l.1-.06,2.06-1.19a2,2,0,0,0,1-1.51V121.49l-2.5,1.47v87.55a1.31,1.31,0,0,1-.61,1.11h-.06Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.9,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-10"
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M332.31,79.44l27.23,15.69a1.51,1.51,0,0,1,.7,1.15c0,.42-.31.58-.7.35L332.31,80.94a1.47,1.47,0,0,1-.69-1.15C331.62,79.37,331.93,79.22,332.31,79.44Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M342.72,109.48,353,115.42a1.47,1.47,0,0,1,.69,1.15c0,.41-.31.57-.69.35L342.72,111a1.46,1.46,0,0,1-.7-1.15C342,109.42,342.33,109.26,342.72,109.48Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M342.72,115.49,353,121.42a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35L342.72,117a1.51,1.51,0,0,1-.7-1.15C342,115.42,342.33,115.27,342.72,115.49Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M362.23,96.68l54.53,31.4a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-54.53-31.4a1.51,1.51,0,0,1-.69-1.16C361.54,96.62,361.85,96.46,362.23,96.68Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M342.94,151.61l16.6,9.61a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-16.6-9.61a1.47,1.47,0,0,1-.69-1.15C342.25,151.55,342.56,151.39,342.94,151.61Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M362.23,162.77l54.53,31.44a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-54.53-31.44a1.47,1.47,0,0,1-.69-1.15C361.54,162.7,361.85,162.55,362.23,162.77Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M332.31,85.46,346,93.34a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.58-.69.35L332.31,87a1.47,1.47,0,0,1-.69-1.15C331.62,85.4,331.93,85.24,332.31,85.46Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,85.46,346,93.34a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.58-.69.35L332.31,87a1.47,1.47,0,0,1-.69-1.15C331.62,85.4,331.93,85.24,332.31,85.46Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M332.31,91.46l6.42,3.7a1.47,1.47,0,0,1,.69,1.15c0,.41-.31.57-.69.35L332.31,93a1.47,1.47,0,0,1-.69-1.15C331.62,91.39,331.93,91.24,332.31,91.46Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,91.46l6.42,3.7a1.47,1.47,0,0,1,.69,1.15c0,.41-.31.57-.69.35L332.31,93a1.47,1.47,0,0,1-.69-1.15C331.62,91.39,331.93,91.24,332.31,91.46Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M332.31,103.47l6.42,3.7a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-6.42-3.7a1.51,1.51,0,0,1-.69-1.16C331.62,103.41,331.93,103.25,332.31,103.47Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,103.47l6.42,3.7a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-6.42-3.7a1.51,1.51,0,0,1-.69-1.16C331.62,103.41,331.93,103.25,332.31,103.47Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M332.31,109.48l6.42,3.7a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-6.42-3.7a1.47,1.47,0,0,1-.69-1.15C331.62,109.42,331.93,109.26,332.31,109.48Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,109.48l6.42,3.7a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-6.42-3.7a1.47,1.47,0,0,1-.69-1.15C331.62,109.42,331.93,109.26,332.31,109.48Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M348.72,94.89l8.22,4.77a1.51,1.51,0,0,1,.7,1.15c0,.42-.31.57-.7.35l-8.22-4.76a1.51,1.51,0,0,1-.7-1.16C348,94.83,348.33,94.67,348.72,94.89Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348.72,94.89l8.22,4.77a1.51,1.51,0,0,1,.7,1.15c0,.42-.31.57-.7.35l-8.22-4.76a1.51,1.51,0,0,1-.7-1.16C348,94.83,348.33,94.67,348.72,94.89Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M361.44,138.33l55.32,31.85a1.47,1.47,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-55.32-31.85a1.51,1.51,0,0,1-.7-1.15C360.74,138.26,361.05,138.11,361.44,138.33Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M408.53,159.4l8.23,4.76a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-8.23-4.76a1.47,1.47,0,0,1-.69-1.15C407.84,159.33,408.15,159.17,408.53,159.4Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M350.52,126l55.32,31.85a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35L350.52,127.5a1.51,1.51,0,0,1-.69-1.16C349.83,125.93,350.14,125.77,350.52,126Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M342.72,97.47l13.71,7.88a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L342.72,99a1.51,1.51,0,0,1-.7-1.15C342,97.4,342.33,97.24,342.72,97.47Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.72,97.47l13.71,7.88a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L342.72,99a1.51,1.51,0,0,1-.7-1.15C342,97.4,342.33,97.24,342.72,97.47Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M359.12,106.9,416.35,140a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35L359.12,108.4a1.47,1.47,0,0,1-.69-1.15C358.43,106.83,358.74,106.68,359.12,106.9Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M359.12,106.9,416.35,140a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35L359.12,108.4a1.47,1.47,0,0,1-.69-1.15C358.43,106.83,358.74,106.68,359.12,106.9Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M342.72,133.64l74,42.69a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.58-.69.36l-74-42.7A1.47,1.47,0,0,1,342,134C342,133.57,342.33,133.42,342.72,133.64Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M332.31,127.63l6.42,3.7a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-6.42-3.7a1.47,1.47,0,0,1-.69-1.15C331.62,127.57,331.93,127.41,332.31,127.63Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,127.63l6.42,3.7a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-6.42-3.7a1.47,1.47,0,0,1-.69-1.15C331.62,127.57,331.93,127.41,332.31,127.63Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M342.72,139.64l74,42.7a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-74-42.7A1.47,1.47,0,0,1,342,140C342,139.58,342.33,139.42,342.72,139.64Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M332.31,133.64l6.42,3.7a1.47,1.47,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-6.42-3.7a1.47,1.47,0,0,1-.69-1.15C331.62,133.57,331.93,133.42,332.31,133.64Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,133.64l6.42,3.7a1.47,1.47,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-6.42-3.7a1.47,1.47,0,0,1-.69-1.15C331.62,133.57,331.93,133.42,332.31,133.64Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M342.72,145.65l74,42.7a1.47,1.47,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-74-42.7A1.47,1.47,0,0,1,342,146C342,145.58,342.33,145.43,342.72,145.65Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M332.31,139.64l6.42,3.7a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.58-.69.36l-6.42-3.71a1.47,1.47,0,0,1-.69-1.15C331.62,139.58,331.93,139.42,332.31,139.64Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.31,139.64l6.42,3.7a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.58-.69.36l-6.42-3.71a1.47,1.47,0,0,1-.69-1.15C331.62,139.58,331.93,139.42,332.31,139.64Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.31,73.41l3.77,2.18a1.52,1.52,0,0,1,.68,1.19v1.39c0,.43-.3.61-.68.39l-3.77-2.18a1.5,1.5,0,0,1-.69-1.18V73.81C321.62,73.37,321.93,73.2,322.31,73.41Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,79.48l3.77,2.18a1.52,1.52,0,0,1,.68,1.18v1.39c0,.44-.3.61-.68.4l-3.77-2.18a1.52,1.52,0,0,1-.69-1.19V79.87C321.62,79.44,321.93,79.26,322.31,79.48Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,85.54l3.77,2.18a1.52,1.52,0,0,1,.68,1.19V90.3c0,.43-.3.61-.68.39l-3.77-2.18a1.53,1.53,0,0,1-.69-1.18V85.94C321.62,85.5,321.93,85.33,322.31,85.54Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,91.61l3.77,2.18a1.52,1.52,0,0,1,.68,1.18v1.39c0,.44-.3.61-.68.4l-3.77-2.18a1.52,1.52,0,0,1-.69-1.19V92C321.62,91.57,321.93,91.39,322.31,91.61Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,97.67l3.77,2.18a1.52,1.52,0,0,1,.68,1.19v1.38c0,.44-.3.62-.68.4l-3.77-2.18a1.53,1.53,0,0,1-.69-1.18V98.07C321.62,97.63,321.93,97.45,322.31,97.67Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,103.74l3.77,2.18a1.49,1.49,0,0,1,.68,1.18v1.39c0,.44-.3.61-.68.4l-3.77-2.18a1.52,1.52,0,0,1-.69-1.19v-1.39C321.62,103.7,321.93,103.52,322.31,103.74Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,109.8l3.77,2.18a1.52,1.52,0,0,1,.68,1.19v1.38c0,.44-.3.62-.68.4l-3.77-2.18a1.53,1.53,0,0,1-.69-1.18V110.2C321.62,109.76,321.93,109.58,322.31,109.8Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,115.87l3.77,2.18a1.49,1.49,0,0,1,.68,1.18v1.39c0,.44-.3.61-.68.39l-3.77-2.17a1.52,1.52,0,0,1-.69-1.19v-1.39C321.62,115.83,321.93,115.65,322.31,115.87Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,121.93l3.77,2.18a1.52,1.52,0,0,1,.68,1.19v1.38c0,.44-.3.62-.68.4l-3.77-2.18a1.52,1.52,0,0,1-.69-1.19v-1.38C321.62,121.89,321.93,121.71,322.31,121.93Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,128l3.77,2.18a1.49,1.49,0,0,1,.68,1.18v1.39c0,.44-.3.61-.68.39L322.31,131a1.52,1.52,0,0,1-.69-1.19v-1.39C321.62,128,321.93,127.78,322.31,128Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,134.06l3.77,2.18a1.52,1.52,0,0,1,.68,1.19v1.38c0,.44-.3.62-.68.4L322.31,137a1.52,1.52,0,0,1-.69-1.19v-1.38C321.62,134,321.93,133.84,322.31,134.06Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.31,140.13l3.77,2.17a1.52,1.52,0,0,1,.68,1.19v1.39c0,.44-.3.61-.68.39l-3.77-2.17a1.52,1.52,0,0,1-.69-1.19v-1.39C321.62,140.09,321.93,139.91,322.31,140.13Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M297.28,53.71l20.4,11.78a3,3,0,0,1,1.37,2.37V91.42c0,.87-.61,1.23-1.37.79l-20.4-11.78a3,3,0,0,1-1.37-2.37V54.51C295.91,53.63,296.52,53.28,297.28,53.71Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17,77.06l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C298.48,77,298.79,76.84,299.17,77.06Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,77.06l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C298.48,77,298.79,76.84,299.17,77.06Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17,57.77l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35l-1.88-1.08a1.51,1.51,0,0,1-.69-1.16C298.48,57.71,298.79,57.55,299.17,57.77Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,57.77l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35l-1.88-1.08a1.51,1.51,0,0,1-.69-1.16C298.48,57.71,298.79,57.55,299.17,57.77Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M301.81,63.15l1.88,1.08a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-1.88-1.08a1.47,1.47,0,0,1-.69-1.15C301.12,63.08,301.43,62.93,301.81,63.15Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,63.15l1.88,1.08a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-1.88-1.08a1.47,1.47,0,0,1-.69-1.15C301.12,63.08,301.43,62.93,301.81,63.15Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M301.81,67l1.88,1.09a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.47,1.47,0,0,1-.69-1.15C301.12,66.93,301.43,66.77,301.81,67Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,67l1.88,1.09a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.47,1.47,0,0,1-.69-1.15C301.12,66.93,301.43,66.77,301.81,67Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17,69.34l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35l-1.88-1.08a1.51,1.51,0,0,1-.69-1.16C298.48,69.28,298.79,69.12,299.17,69.34Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,69.34l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35l-1.88-1.08a1.51,1.51,0,0,1-.69-1.16C298.48,69.28,298.79,69.12,299.17,69.34Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M301.81,74.72l1.88,1.09a1.47,1.47,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C301.12,74.66,301.43,74.5,301.81,74.72Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,74.72l1.88,1.09a1.47,1.47,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C301.12,74.66,301.43,74.5,301.81,74.72Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M304.32,60.74l11.46,6.63a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-11.46-6.62a1.46,1.46,0,0,1-.7-1.16C303.62,60.68,303.93,60.52,304.32,60.74Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,60.74l11.46,6.63a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-11.46-6.62a1.46,1.46,0,0,1-.7-1.16C303.62,60.68,303.93,60.52,304.32,60.74Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M304.32,80l11.46,6.63a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-11.46-6.62a1.51,1.51,0,0,1-.7-1.16C303.62,80,303.93,79.81,304.32,80Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,80l11.46,6.63a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-11.46-6.62a1.51,1.51,0,0,1-.7-1.16C303.62,80,303.93,79.81,304.32,80Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M307,66.12l8.82,5.1a1.46,1.46,0,0,1,.7,1.16c0,.41-.31.57-.7.35L307,67.62a1.51,1.51,0,0,1-.7-1.15C306.26,66.05,306.57,65.9,307,66.12Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307,66.12l8.82,5.1a1.46,1.46,0,0,1,.7,1.16c0,.41-.31.57-.7.35L307,67.62a1.51,1.51,0,0,1-.7-1.15C306.26,66.05,306.57,65.9,307,66.12Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M307,70l8.82,5.11a1.51,1.51,0,0,1,.7,1.15c0,.42-.31.57-.7.35L307,71.48a1.51,1.51,0,0,1-.7-1.15C306.26,69.91,306.57,69.75,307,70Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307,70l8.82,5.11a1.51,1.51,0,0,1,.7,1.15c0,.42-.31.57-.7.35L307,71.48a1.51,1.51,0,0,1-.7-1.15C306.26,69.91,306.57,69.75,307,70Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M304.32,72.32l11.46,6.62a1.51,1.51,0,0,1,.7,1.15c0,.42-.31.57-.7.35l-11.46-6.62a1.51,1.51,0,0,1-.7-1.15C303.62,72.25,303.93,72.1,304.32,72.32Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,72.32l11.46,6.62a1.51,1.51,0,0,1,.7,1.15c0,.42-.31.57-.7.35l-11.46-6.62a1.51,1.51,0,0,1-.7-1.15C303.62,72.25,303.93,72.1,304.32,72.32Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M307,77.69l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,79.19a1.46,1.46,0,0,1-.7-1.15C306.26,77.63,306.57,77.47,307,77.69Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307,77.69l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,79.19a1.46,1.46,0,0,1-.7-1.15C306.26,77.63,306.57,77.47,307,77.69Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M297.28,84.87l20.4,11.77A3,3,0,0,1,319.05,99v46.54c0,.88-.61,1.23-1.37.79l-20.4-11.78a3,3,0,0,1-1.37-2.37V85.66C295.91,84.78,296.52,84.43,297.28,84.87Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17,88.92,301.05,90a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35l-1.88-1.08a1.47,1.47,0,0,1-.69-1.15C298.48,88.86,298.79,88.7,299.17,88.92Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,88.92,301.05,90a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35l-1.88-1.08a1.47,1.47,0,0,1-.69-1.15C298.48,88.86,298.79,88.7,299.17,88.92Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M301.81,94.3l1.88,1.08a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C301.12,94.23,301.43,94.08,301.81,94.3Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,94.3l1.88,1.08a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C301.12,94.23,301.43,94.08,301.81,94.3Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M301.81,98.15l1.88,1.08a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.47,1.47,0,0,1-.69-1.15C301.12,98.08,301.43,97.92,301.81,98.15Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,98.15l1.88,1.08a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.47,1.47,0,0,1-.69-1.15C301.12,98.08,301.43,97.92,301.81,98.15Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17,100.5l1.88,1.08a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35L299.17,102a1.47,1.47,0,0,1-.69-1.15C298.48,100.43,298.79,100.27,299.17,100.5Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,100.5l1.88,1.08a1.51,1.51,0,0,1,.7,1.15c0,.42-.32.57-.7.35L299.17,102a1.47,1.47,0,0,1-.69-1.15C298.48,100.43,298.79,100.27,299.17,100.5Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M304.32,91.9l11.46,6.62a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L304.32,93.4a1.51,1.51,0,0,1-.7-1.15C303.62,91.83,303.93,91.67,304.32,91.9Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,91.9l11.46,6.62a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L304.32,93.4a1.51,1.51,0,0,1-.7-1.15C303.62,91.83,303.93,91.67,304.32,91.9Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M307,97.27l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,98.77a1.51,1.51,0,0,1-.7-1.15C306.26,97.2,306.57,97.05,307,97.27Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307,97.27l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,98.77a1.51,1.51,0,0,1-.7-1.15C306.26,97.2,306.57,97.05,307,97.27Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M307,101.13l8.82,5.1a1.51,1.51,0,0,1,.7,1.15c0,.42-.31.58-.7.36L307,102.63a1.51,1.51,0,0,1-.7-1.15C306.26,101.06,306.57,100.9,307,101.13Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307,101.13l8.82,5.1a1.51,1.51,0,0,1,.7,1.15c0,.42-.31.58-.7.36L307,102.63a1.51,1.51,0,0,1-.7-1.15C306.26,101.06,306.57,100.9,307,101.13Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M304.32,103.47l11.46,6.62a1.51,1.51,0,0,1,.7,1.15c0,.42-.31.57-.7.35L304.32,105a1.51,1.51,0,0,1-.7-1.15C303.62,103.4,303.93,103.25,304.32,103.47Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,103.47l11.46,6.62a1.51,1.51,0,0,1,.7,1.15c0,.42-.31.57-.7.35L304.32,105a1.51,1.51,0,0,1-.7-1.15C303.62,103.4,303.93,103.25,304.32,103.47Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M301.81,105.89l1.88,1.09a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.47,1.47,0,0,1-.69-1.15C301.12,105.83,301.43,105.67,301.81,105.89Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,105.89l1.88,1.09a1.47,1.47,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.47,1.47,0,0,1-.69-1.15C301.12,105.83,301.43,105.67,301.81,105.89Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M301.81,109.74l1.88,1.09a1.47,1.47,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C301.12,109.68,301.43,109.52,301.81,109.74Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,109.74l1.88,1.09a1.47,1.47,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C301.12,109.68,301.43,109.52,301.81,109.74Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M307,108.86l8.82,5.11a1.51,1.51,0,0,1,.7,1.15c0,.42-.31.58-.7.35l-8.82-5.1a1.51,1.51,0,0,1-.7-1.15C306.26,108.8,306.57,108.64,307,108.86Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307,108.86l8.82,5.11a1.51,1.51,0,0,1,.7,1.15c0,.42-.31.58-.7.35l-8.82-5.1a1.51,1.51,0,0,1-.7-1.15C306.26,108.8,306.57,108.64,307,108.86Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M307,112.72l8.82,5.11a1.51,1.51,0,0,1,.7,1.15c0,.42-.31.57-.7.35L307,114.22a1.46,1.46,0,0,1-.7-1.15C306.26,112.66,306.57,112.5,307,112.72Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307,112.72l8.82,5.11a1.51,1.51,0,0,1,.7,1.15c0,.42-.31.57-.7.35L307,114.22a1.46,1.46,0,0,1-.7-1.15C306.26,112.66,306.57,112.5,307,112.72Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17,119.83l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.41-.32.57-.7.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C298.48,119.77,298.79,119.61,299.17,119.83Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,119.83l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.41-.32.57-.7.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C298.48,119.77,298.79,119.61,299.17,119.83Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M304.32,122.8l11.46,6.63a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-11.46-6.62a1.51,1.51,0,0,1-.7-1.15C303.62,122.74,303.93,122.58,304.32,122.8Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,122.8l11.46,6.63a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-11.46-6.62a1.51,1.51,0,0,1-.7-1.15C303.62,122.74,303.93,122.58,304.32,122.8Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M301.81,125.23l1.88,1.09a1.47,1.47,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C301.12,125.17,301.43,125,301.81,125.23Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,125.23l1.88,1.09a1.47,1.47,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C301.12,125.17,301.43,125,301.81,125.23Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M301.81,129.08l1.88,1.08a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C301.12,129,301.43,128.86,301.81,129.08Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,129.08l1.88,1.08a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C301.12,129,301.43,128.86,301.81,129.08Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M307,128.2l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,129.7a1.46,1.46,0,0,1-.7-1.15C306.26,128.14,306.57,128,307,128.2Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307,128.2l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,129.7a1.46,1.46,0,0,1-.7-1.15C306.26,128.14,306.57,128,307,128.2Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M307,132.06l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,133.56a1.51,1.51,0,0,1-.7-1.15C306.26,132,306.57,131.84,307,132.06Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307,132.06l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,133.56a1.51,1.51,0,0,1-.7-1.15C306.26,132,306.57,131.84,307,132.06Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M301.81,113.57l1.88,1.09a1.47,1.47,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C301.12,113.51,301.43,113.35,301.81,113.57Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,113.57l1.88,1.09a1.47,1.47,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C301.12,113.51,301.43,113.35,301.81,113.57Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17,115.92l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.41-.32.57-.7.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C298.48,115.86,298.79,115.7,299.17,115.92Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,115.92l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.41-.32.57-.7.35l-1.88-1.09a1.47,1.47,0,0,1-.69-1.15C298.48,115.86,298.79,115.7,299.17,115.92Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M307,116.55l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,118.05a1.46,1.46,0,0,1-.7-1.15C306.26,116.49,306.57,116.33,307,116.55Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307,116.55l8.82,5.11a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L307,118.05a1.46,1.46,0,0,1-.7-1.15C306.26,116.49,306.57,116.33,307,116.55Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M304.32,118.89l11.46,6.63a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-11.46-6.62a1.51,1.51,0,0,1-.7-1.16C303.62,118.83,303.93,118.67,304.32,118.89Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,118.89l11.46,6.63a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-11.46-6.62a1.51,1.51,0,0,1-.7-1.16C303.62,118.83,303.93,118.67,304.32,118.89Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M299.17,131.48l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.41-.32.57-.7.35L299.17,133a1.47,1.47,0,0,1-.69-1.15C298.48,131.42,298.79,131.26,299.17,131.48Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.17,131.48l1.88,1.09a1.51,1.51,0,0,1,.7,1.15c0,.41-.32.57-.7.35L299.17,133a1.47,1.47,0,0,1-.69-1.15C298.48,131.42,298.79,131.26,299.17,131.48Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M304.32,134.46l11.46,6.62a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L304.32,136a1.51,1.51,0,0,1-.7-1.15C303.62,134.39,303.93,134.23,304.32,134.46Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,134.46l11.46,6.62a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L304.32,136a1.51,1.51,0,0,1-.7-1.15C303.62,134.39,303.93,134.23,304.32,134.46Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.8,
    style: {
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-10-3",
    "data-name": "freepik--window--inject-10"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.78,150.29v76.38a3.5,3.5,0,0,0,1.59,2.75l43.88,25.32a1.08,1.08,0,0,0,.53.15h.42l.09-.06.09-.08a1.22,1.22,0,0,0,.29-.42,2,2,0,0,0,.17-.8v-76a3.5,3.5,0,0,0-1.59-2.75l-43.88-25.29a1.16,1.16,0,0,0-1.07-.14l-.13.08h0l-.11.1v.06a.41.41,0,0,0-.05.09.54.54,0,0,0-.1.2.33.33,0,0,0,0,.14h0v.15C410.79,150.16,410.78,150.23,410.78,150.29Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M411.3,149.24a1.16,1.16,0,0,1,1.07.14l43.88,25.29a3.5,3.5,0,0,1,1.59,2.75v5.18l2.53-1.46V176a3.48,3.48,0,0,0-1.59-2.74L414.9,148a1.11,1.11,0,0,0-1.15-.1C413.46,148,411.64,149.07,411.3,149.24Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M410.79,150.28c0-1,.71-1.4,1.58-.9l43.88,25.29a3.5,3.5,0,0,1,1.59,2.75v5.18l-47-27.11Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.37,149.38l43.88,25.29a3.25,3.25,0,0,1,1.12,1.18l2.52-1.45a3.22,3.22,0,0,0-1.11-1.15L414.9,148a1.11,1.11,0,0,0-1.15-.1c-.28.18-2.11,1.2-2.44,1.38A1.11,1.11,0,0,1,412.37,149.38Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M460.37,181.15V176a3.32,3.32,0,0,0-.48-1.59l-2.53,1.44a3.15,3.15,0,0,1,.48,1.58v5.18Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M455.53,176.8a2.38,2.38,0,0,1,.9,1.9c0,.76-.4,1.15-.9.86a2.36,2.36,0,0,1-.9-1.89C454.63,176.9,455,176.52,455.53,176.8Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M452.3,174.94a2.32,2.32,0,0,1,.9,1.89c0,.77-.4,1.15-.9.87a2.4,2.4,0,0,1-.89-1.9C451.41,175,451.81,174.65,452.3,174.94Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M449.08,173.07A2.41,2.41,0,0,1,450,175c0,.76-.4,1.15-.89.86a2.35,2.35,0,0,1-.9-1.9C448.18,173.17,448.58,172.79,449.08,173.07Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.26,254.74l.19-.11.49-.28h0a1.35,1.35,0,0,1,.26-.15h0l.42-.24.85-.48.2-.11a.9.9,0,0,0,.27-.21,1.15,1.15,0,0,0,.21-.33,1.88,1.88,0,0,0,.19-.84V181.14l-2.53,1.46v70.81a2.44,2.44,0,0,1-.17.8,1.22,1.22,0,0,1-.29.42.24.24,0,0,1-.09.08Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M414.43,164.25a.24.24,0,0,1,.08-.2l1.14-1h.05a.17.17,0,0,1,.09.11.43.43,0,0,1,0,.16v.79a.81.81,0,0,1,0,.22l-.08.12-.61.55.61,1.25c0,.08.06.15.08.22a1,1,0,0,1,0,.24v.91a.08.08,0,0,1-.09,0h0l-.05-.07-1.14-2.37a.6.6,0,0,1-.08-.29Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M418.6,163.15a.3.3,0,0,1,.09-.13h.17l.42.25a.17.17,0,0,1,.09.11.22.22,0,0,1,0,.16v.07l-2,6.08a.22.22,0,0,1-.08.13h-.17l-.41-.24a.2.2,0,0,1-.09-.11.43.43,0,0,1,0-.16v-.07Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M421.63,169a.24.24,0,0,1-.08.21l-1.14,1h-.06a.2.2,0,0,1-.09-.11.43.43,0,0,1,0-.16v-.79a.81.81,0,0,1,0-.22.35.35,0,0,1,.08-.13l.6-.55-.6-1.24a2,2,0,0,1-.08-.22,1,1,0,0,1,0-.24v-.8a.11.11,0,0,1,0-.11h.09s0,0,.06.07l1.14,2.36a.64.64,0,0,1,.08.3Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M424.8,172.11a.28.28,0,0,1,.11.13.67.67,0,0,1,0,.2v.87a.17.17,0,0,1,0,.14.08.08,0,0,1-.11,0l-.54-.31a.28.28,0,0,1-.11-.13.67.67,0,0,1,0-.2V172a.2.2,0,0,1,0-.15.08.08,0,0,1,.11,0Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M426.6,173.15a.28.28,0,0,1,.11.13.67.67,0,0,1,0,.2v.87a.17.17,0,0,1,0,.14.11.11,0,0,1-.11,0l-.54-.31a.35.35,0,0,1-.11-.13.46.46,0,0,1-.05-.2V173a.21.21,0,0,1,.05-.15.08.08,0,0,1,.11,0Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M428.4,174.19a.28.28,0,0,1,.11.13.67.67,0,0,1,0,.2v.87a.17.17,0,0,1,0,.14.08.08,0,0,1-.11,0l-.54-.31a.3.3,0,0,1-.11-.14.41.41,0,0,1-.05-.19V174a.24.24,0,0,1,.05-.14.08.08,0,0,1,.11,0Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M414.91,171.17l26.36,15.22a1.2,1.2,0,0,1,.57.94c0,.34-.25.46-.57.28l-26.36-15.22a1.22,1.22,0,0,1-.56-.93C414.35,171.12,414.6,171,414.91,171.17Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M423.37,190.71l26.36,15.22a1.2,1.2,0,0,1,.57.93c0,.34-.25.47-.57.29l-26.36-15.22a1.22,1.22,0,0,1-.56-.94C422.81,190.65,423.06,190.53,423.37,190.71Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M423.37,200.47,436,207.76a1.22,1.22,0,0,1,.56.94c0,.34-.25.46-.56.28l-12.62-7.29a1.19,1.19,0,0,1-.56-.93C422.81,200.42,423.06,200.29,423.37,200.47Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M443.46,187.65l10.5,6a1.2,1.2,0,0,1,.57.93c0,.34-.26.47-.57.29l-10.5-6a1.19,1.19,0,0,1-.56-.93C442.9,187.6,443.15,187.47,443.46,187.65Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M414.91,224.89l26.36,15.22a1.2,1.2,0,0,1,.57.93c0,.34-.25.47-.57.29l-26.36-15.22a1.22,1.22,0,0,1-.56-.94C414.35,224.83,414.6,224.71,414.91,224.89Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M443.46,241.37l10.5,6a1.22,1.22,0,0,1,.57.94c0,.33-.26.46-.57.28l-10.5-6a1.22,1.22,0,0,1-.56-.94C442.9,241.32,443.15,241.19,443.46,241.37Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M443.46,226.74l10.5,6a1.2,1.2,0,0,1,.57.93c0,.34-.26.47-.57.29l-10.5-6a1.22,1.22,0,0,1-.56-.94C442.9,226.69,443.15,226.56,443.46,226.74Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M443.46,231.63l10.5,6a1.2,1.2,0,0,1,.57.93c0,.34-.26.47-.57.29l-10.5-6a1.22,1.22,0,0,1-.56-.94C442.9,231.57,443.15,231.45,443.46,231.63Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M434.5,221.56l5.9,3.41a1.2,1.2,0,0,1,.57.93c0,.34-.25.47-.57.29l-5.9-3.41a1.22,1.22,0,0,1-.56-.94C433.94,221.51,434.19,221.38,434.5,221.56Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M414.91,176.07l15.38,8.87a1.22,1.22,0,0,1,.56.93c0,.34-.25.47-.56.29l-15.38-8.87a1.22,1.22,0,0,1-.56-.94C414.35,176,414.6,175.89,414.91,176.07Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,176.07l15.38,8.87a1.22,1.22,0,0,1,.56.93c0,.34-.25.47-.56.29l-15.38-8.87a1.22,1.22,0,0,1-.56-.94C414.35,176,414.6,175.89,414.91,176.07Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M414.91,180.94l5.22,3a1.22,1.22,0,0,1,.56.93c0,.34-.25.47-.56.29l-5.22-3a1.22,1.22,0,0,1-.56-.93C414.35,180.89,414.6,180.76,414.91,180.94Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,180.94l5.22,3a1.22,1.22,0,0,1,.56.93c0,.34-.25.47-.56.29l-5.22-3a1.22,1.22,0,0,1-.56-.93C414.35,180.89,414.6,180.76,414.91,180.94Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M414.91,185.82l5.22,3a1.22,1.22,0,0,1,.56.94c0,.33-.25.46-.56.28l-5.22-3a1.16,1.16,0,0,1-.56-.93C414.35,185.77,414.6,185.64,414.91,185.82Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,185.82l5.22,3a1.22,1.22,0,0,1,.56.94c0,.33-.25.46-.56.28l-5.22-3a1.16,1.16,0,0,1-.56-.93C414.35,185.77,414.6,185.64,414.91,185.82Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M414.91,190.71l5.22,3a1.19,1.19,0,0,1,.56.93c0,.34-.25.47-.56.29l-5.22-3a1.22,1.22,0,0,1-.56-.94C414.35,190.65,414.6,190.53,414.91,190.71Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,190.71l5.22,3a1.22,1.22,0,0,1,.56.94c0,.34-.25.46-.56.28l-5.22-3a1.22,1.22,0,0,1-.56-.94C414.35,190.65,414.6,190.53,414.91,190.71Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.37,195.59l15.38,8.87a1.22,1.22,0,0,1,.56.94c0,.33-.25.46-.56.28l-15.38-8.87a1.22,1.22,0,0,1-.56-.94C422.81,195.54,423.06,195.41,423.37,195.59Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.93,205.72l6.69,3.88a1.16,1.16,0,0,1,.56.93c0,.34-.25.47-.56.29l-6.69-3.88a1.22,1.22,0,0,1-.56-.93C440.37,205.67,440.62,205.54,440.93,205.72Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.37,195.59l15.38,8.87a1.22,1.22,0,0,1,.56.94c0,.33-.25.46-.56.28l-15.38-8.87a1.22,1.22,0,0,1-.56-.94C422.81,195.54,423.06,195.41,423.37,195.59Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.93,205.72l6.69,3.88a1.16,1.16,0,0,1,.56.93c0,.34-.25.47-.56.29l-6.69-3.88a1.22,1.22,0,0,1-.56-.93C440.37,205.67,440.62,205.54,440.93,205.72Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M414.91,195.59l5.22,3a1.22,1.22,0,0,1,.56.93c0,.34-.25.47-.56.29l-5.22-3a1.22,1.22,0,0,1-.56-.93C414.35,195.54,414.6,195.41,414.91,195.59Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,195.59l5.22,3a1.22,1.22,0,0,1,.56.93c0,.34-.25.47-.56.29l-5.22-3a1.22,1.22,0,0,1-.56-.93C414.35,195.54,414.6,195.41,414.91,195.59Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M432.47,186.2l6.69,3.87a1.22,1.22,0,0,1,.56.94c0,.33-.25.46-.56.28l-6.69-3.87a1.22,1.22,0,0,1-.56-.94C431.91,186.15,432.16,186,432.47,186.2Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M432.47,186.2l6.69,3.87a1.22,1.22,0,0,1,.56.94c0,.33-.25.46-.56.28l-6.69-3.87a1.22,1.22,0,0,1-.56-.94C431.91,186.15,432.16,186,432.47,186.2Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M429.71,209l15.38,8.87a1.22,1.22,0,0,1,.57.94c0,.34-.26.46-.57.29l-15.38-8.88a1.22,1.22,0,0,1-.56-.93C429.15,209,429.4,208.83,429.71,209Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M438.59,219,454,227.91a1.22,1.22,0,0,1,.57.94c0,.33-.26.46-.57.28l-15.37-8.87a1.2,1.2,0,0,1-.57-.94C438,219,438.27,218.86,438.59,219Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M447.28,219.15,454,223a1.2,1.2,0,0,1,.57.93c0,.34-.26.47-.57.29l-6.68-3.87a1.2,1.2,0,0,1-.57-.94C446.71,219.09,447,219,447.28,219.15Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M447.28,238.49l6.68,3.87a1.22,1.22,0,0,1,.57.94c0,.33-.26.46-.57.28l-6.68-3.87a1.2,1.2,0,0,1-.57-.94C446.71,238.44,447,238.31,447.28,238.49Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M423.37,185.82l15.38,8.88a1.19,1.19,0,0,1,.56.93c0,.34-.25.47-.56.29L423.37,187a1.16,1.16,0,0,1-.56-.93C422.81,185.77,423.06,185.64,423.37,185.82Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.37,185.82l15.38,8.88a1.19,1.19,0,0,1,.56.93c0,.34-.25.47-.56.29L423.37,187a1.16,1.16,0,0,1-.56-.93C422.81,185.77,423.06,185.64,423.37,185.82Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M440.93,196l6.69,3.87a1.22,1.22,0,0,1,.56.94c0,.33-.25.46-.56.28l-6.69-3.87a1.22,1.22,0,0,1-.56-.94C440.37,195.9,440.62,195.78,440.93,196Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.93,196l6.69,3.87a1.22,1.22,0,0,1,.56.94c0,.33-.25.46-.56.28l-6.69-3.87a1.22,1.22,0,0,1-.56-.94C440.37,195.9,440.62,195.78,440.93,196Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mouse--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.12,251.91l9.42,5.44a10.4,10.4,0,0,0,10.4-.55l15.55-11.35c2.77-2,2.61-5-.36-6.77l-4.72-2.74a12.83,12.83,0,0,0-10.93-.33L336.29,246C333.22,247.55,333.14,250.19,336.12,251.91Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M371.74,240.51,361,248.92l-7.94,6.21a7,7,0,0,1-2.53.61,6.86,6.86,0,0,1-3.77-.79l-8.43-4.87h-.05a6,6,0,0,1-1.88-8.27,2.33,2.33,0,0,1,.17-.26l.25-.35a11.26,11.26,0,0,1,6.79-4.3l4.27-.85c6.92-1.41,12.59-2.09,13.25-1.64l10.57,6.12Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M365.73,245.22l.61-.48-9.49-5.47,8.3-2.57-.84-.49-8.3,2.57-5.66-3.26-1.07.2Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M354,254.62h0l7.56-5.46,10.19-7.36v-1.2a.11.11,0,0,0-.05-.09h-.06c-.76-.26-5.18,1.07-10.52,3.19l-3.54,1.41a11.2,11.2,0,0,0-7.1,10.47v.18a7,7,0,0,0,2.53-.61Z",
    transform: "translate(-25.13 -24.88)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-10"
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M372.7,405.51c-10.38-10.71-16.47-54.29-6.35-62.78h51.5c10.12,8.49,4,52.06-6.34,62.77l-.29.3c-.11.12-.23.24-.35.35-.3.29-.61.57-.94.84l-.25.2c-.25.2-.5.4-.78.6s-.88.6-1.34.87c-8.54,5-22.38,5-30.92,0h0c-.45-.26-.9-.56-1.35-.88-.26-.18-.49-.37-.73-.56l-.3-.24a9.94,9.94,0,0,1-.91-.81c-.14-.13-.28-.27-.41-.41A1.88,1.88,0,0,1,372.7,405.51Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.7,405.51c-10.38-10.71-16.47-54.29-6.35-62.78h51.5c10.12,8.49,4,52.06-6.34,62.77l-.29.3c-.11.12-.23.24-.35.35-.3.29-.61.57-.94.84l-.25.2c-.25.2-.5.4-.78.6s-.88.6-1.34.87c-8.54,5-22.38,5-30.92,0h0c-.45-.26-.9-.56-1.35-.88-.26-.18-.49-.37-.73-.56l-.3-.24a9.94,9.94,0,0,1-.91-.81c-.14-.13-.28-.27-.41-.41A1.88,1.88,0,0,1,372.7,405.51Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#fff"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M413.38,339.31c11.75,6.86,11.75,18,0,24.85s-30.81,6.86-42.56,0-11.75-18,0-24.85S401.63,332.45,413.38,339.31Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.38,339.31c11.75,6.86,11.75,18,0,24.85s-30.81,6.86-42.56,0-11.75-18,0-24.85S401.63,332.45,413.38,339.31Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#fff"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M407.73,342.61c8.63,5,8.63,13.21,0,18.25s-22.63,5-31.26,0-8.63-13.21,0-18.25S399.1,337.57,407.73,342.61Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.73,342.61c8.63,5,8.63,13.21,0,18.25s-22.63,5-31.26,0-8.63-13.21,0-18.25S399.1,337.57,407.73,342.61Z",
    transform: "translate(-25.13 -24.88)"
  }))), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M376.47,351.27c8.63-5,22.63-5,31.26,0a14.37,14.37,0,0,1,5.16,4.79,14.48,14.48,0,0,1-5.16,4.8c-8.63,5-22.63,5-31.26,0a14.51,14.51,0,0,1-5.17-4.8A14.49,14.49,0,0,1,376.47,351.27Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-10"
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M387.88,329.28a14.35,14.35,0,0,1-1.31-3.76c-.58-3.14.2-6.73,2.74-8.67,1-.76,2.33-1.33,2.76-2.53a4,4,0,0,0,0-2.07c-.47-2.68-1.37-5.44-.63-8.05a9,9,0,0,1,5-5.36,26.89,26.89,0,0,1,7.27-1.9,11.73,11.73,0,0,0,3.85-1.1c1.44-.81,1.89-2.23,2.78-3.48a24.3,24.3,0,0,1,3.54-3.77c2.62-2.34,5.9-4.27,9.53-4.11,7.58.33,7.36,6.85,5.18,11.79s-2.76,6.55,2,11.7,4.74,11.5-.91,15-9.32,4-7.08,10.86c2,6.11,3.23,11.32-2.41,17.85-3.65,4.22-8.64,7.23-14.88,7A25.16,25.16,0,0,1,398,357c-1.72-.85-.56-2.18-1.14-3.88l-3.74-10.92a81.34,81.34,0,0,0-3-8.62C389.43,332.08,388.59,330.71,387.88,329.28Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.88,329.28a14.35,14.35,0,0,1-1.31-3.76c-.58-3.14.2-6.73,2.74-8.67,1-.76,2.33-1.33,2.76-2.53a4,4,0,0,0,0-2.07c-.47-2.68-1.37-5.44-.63-8.05a9,9,0,0,1,5-5.36,26.89,26.89,0,0,1,7.27-1.9,11.73,11.73,0,0,0,3.85-1.1c1.44-.81,1.89-2.23,2.78-3.48a24.3,24.3,0,0,1,3.54-3.77c2.62-2.34,5.9-4.27,9.53-4.11,7.58.33,7.36,6.85,5.18,11.79s-2.76,6.55,2,11.7,4.74,11.5-.91,15-9.32,4-7.08,10.86c2,6.11,3.23,11.32-2.41,17.85-3.65,4.22-8.64,7.23-14.88,7A25.16,25.16,0,0,1,398,357c-1.72-.85-.56-2.18-1.14-3.88l-3.74-10.92a81.34,81.34,0,0,0-3-8.62C389.43,332.08,388.59,330.71,387.88,329.28Z",
    transform: "translate(-25.13 -24.88)"
  }))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M398.18,357a.53.53,0,0,0,.37-.53c-.32-37.42,20.31-59.76,20.52-60a.59.59,0,0,0,0-.8.56.56,0,0,0-.79,0c-.21.22-21.14,22.87-20.82,60.76a.55.55,0,0,0,.54.56h.18Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#fff"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M404.18,322.17l.12-.05c6.71-4.23,18.68-7.38,18.8-7.41a.57.57,0,0,0,.4-.69.53.53,0,0,0-.66-.4h0c-.5.13-12.26,3.22-19.11,7.54a.54.54,0,0,0-.19.75v0A.56.56,0,0,0,404.18,322.17Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#fff"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M406.26,317h0a.57.57,0,0,0,.31-.74,43.47,43.47,0,0,0-6.19-10.41.54.54,0,0,0-.77-.07h0a.57.57,0,0,0-.06.79,43.18,43.18,0,0,1,6,10.11.55.55,0,0,0,.71.32Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#fff"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M392.92,361a31.49,31.49,0,0,1-16.43.6c-9.42-2-15.19-10.84-15.19-10.84s10.2-4.08,16.14-4.48a52.71,52.71,0,0,0-17.85.38s-5.46-2-4.43-11.24c0,0,5.14-3.79,17-2.3,0,0-5.92-4.23-16.31-5.48-.82,0,.29-12,1.28-17.35s3-4.52,7.2-4.06,16.81,3.32,18.4,6.4,0,10.94,0,10.94a18,18,0,0,0,3.46-10.28s4.73,1.73,7.26,4A16.91,16.91,0,0,1,398,323c-.59,4.21-2.57,10.64-5.35,14.23,0,0,6.26-4.05,7.69-11.49a26,26,0,0,1,5,14.65C405.22,349.75,401,356.74,392.92,361Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M392.92,361a31.49,31.49,0,0,1-16.43.6c-9.42-2-15.19-10.84-15.19-10.84s10.2-4.08,16.14-4.48a52.71,52.71,0,0,0-17.85.38s-5.46-2-4.43-11.24c0,0,5.14-3.79,17-2.3,0,0-5.92-4.23-16.31-5.48-.82,0,.29-12,1.28-17.35s3-4.52,7.2-4.06,16.81,3.32,18.4,6.4,0,10.94,0,10.94a18,18,0,0,0,3.46-10.28s4.73,1.73,7.26,4A16.91,16.91,0,0,1,398,323c-.59,4.21-2.57,10.64-5.35,14.23,0,0,6.26-4.05,7.69-11.49a26,26,0,0,1,5,14.65C405.22,349.75,401,356.74,392.92,361Z",
    transform: "translate(-25.13 -24.88)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M394.17,360.19a.51.51,0,0,1-.34-.46c-1.43-17.86-21.41-45.75-30.24-51.35a.56.56,0,0,1-.17-.75.55.55,0,0,1,.74-.17c9,5.69,29.29,34,30.73,52.18a.53.53,0,0,1-.48.58h0A.45.45,0,0,1,394.17,360.19Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-10-2",
    "data-name": "freepik--character--inject-10"
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M213.49,349c0-.2-3.21-11.8-3.21-11.8s1.05,1.07,7.75-.7a37.88,37.88,0,0,0,7.29-3.06l1.91,8.48c1.79,3.26,7.71,1.76,14.19,1,1.09-.13,2.21-.31,3.33-.5h.07c3.5-.19,7,1.91,3.38,4.9s-9.65,4.11-15.18,5.11C226.36,353.68,214.68,355.63,213.49,349Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#ffa8a7"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M260,348a6.78,6.78,0,0,1,.48,3.56c-.12,1.29-3.32,5.67-9,8.36s-12.62,2.86-15.88,3.8-6.26,2.81-10.11,3.75-7.66,1.44-11.52-1.11c-.71-1.09-1.49-3.62-1.27-3.87C213.4,361.83,260,348,260,348Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#263238"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M228.25,343.08c2.48,1.71,7.62.52,13.17-.11,5.24-.6,11.13-2.44,14.69-1.2s6.53,5.42,1.72,10.79c-1.39,1.55-4.33,4.28-6.69,5.13-6,2.14-11.34,2.31-15.18,3.26-5,1.23-7.74,3.45-12.36,4-6,.7-9.78-.84-10.82-2.44s-2-14.49.57-14.22c0,0,1.08,4.17,10.87.12C228.49,346.62,228.42,344,228.25,343.08Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,343.08c2.48,1.71,7.62.52,13.17-.11,5.24-.6,11.13-2.44,14.69-1.2s6.53,5.42,1.72,10.79c-1.39,1.55-4.33,4.28-6.69,5.13-6,2.14-11.34,2.31-15.18,3.26-5,1.23-7.74,3.45-12.36,4-6,.7-9.78-.84-10.82-2.44s-2-14.49.57-14.22c0,0,1.08,4.17,10.87.12C228.49,346.62,228.42,344,228.25,343.08Z",
    transform: "translate(-25.13 -24.88)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M244.85,350s-.56-5.44-4.58-6.88a2.11,2.11,0,0,0-2.22.29s3.73.54,5,6.93c0,0,.19.42,1,.27C244.29,350.55,244.89,350.44,244.85,350Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#fafafa"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M234.62,343.82s0-.18.94-.35a1.64,1.64,0,0,1,1.11.12s3,1.3,3.56,7c0,0,0,.68-.93.87a.82.82,0,0,1-1.05-.49.64.64,0,0,0,0-.07S237.61,344.91,234.62,343.82Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#fafafa"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M231.4,343.94s.17-.34.87-.34c.89,0,1.1.35,1.1.35s2.14,2.19,2.16,6.95c0,0,.09.8-1,.88s-1-.82-1-.82S233.15,344.9,231.4,343.94Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#fafafa"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M209.35,270.2c4.9,14.73,17.9,65.45,17.9,65.45s-8.46,7.6-17.64,4.14l-21.87-63.16Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#37474f"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M247.14,365.4c-1-1.49-4.76-11.8-4.76-11.8s3.92,2.24,10.67.64c3.43-.82,6.64-4.54,6.64-4.54l2.88,9.91c1.7,3.31,7.21,2.22,13.71,1.64,1.09-.1,2.21-.26,3.34-.42h.07c3.5-.1,7,2.08,3.25,5s-9.74,3.88-15.3,4.74C261,371.58,250.89,371,247.14,365.4Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#ffa8a7"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M297.56,365.09a7.3,7.3,0,0,1,.43,3.84c-.17,1.38-3.72,6-9.84,8.73s-13.63,2.74-17.16,3.66-6.79,2.86-10.95,3.77-8.26,1.33-12.33-1.49c-.74-1.2-1.52-3.94-1.26-4.2C247.12,378.71,297.56,365.09,297.56,365.09Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#263238"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M263.63,358.87a9.68,9.68,0,0,0,1.23.76,3.71,3.71,0,0,0,1.36.28,18.93,18.93,0,0,0,3.28.08c2.74-.13,5.47-.55,8.21-.79,5.63-.5,12-2.32,15.79-.9s7.25,6,1.94,11.61a26,26,0,0,1-7.1,5.39c-6.29,2.63-12.82,2.14-17,3.06-5.4,1.19-8.4,3.5-13.38,3.95-6.45.59-10.47-1.16-11.54-2.91-.6-1,.06-6-.74-9.95-.7-3.38-.52-5.68.7-5.53a6.07,6.07,0,0,0,.94,1.2,4.51,4.51,0,0,0,1.43,1.13,11.48,11.48,0,0,0,2.42.81,14.5,14.5,0,0,0,4.49.62,2.13,2.13,0,0,0,1.22-.39,2.57,2.57,0,0,0,.71-1.52c.1-.5.21-1,.31-1.5a2.17,2.17,0,0,1,.28-.77,2.06,2.06,0,0,1,.76-.61A6.56,6.56,0,0,0,261.4,361a5.72,5.72,0,0,0,.72-2.32.55.55,0,0,1,.16-.38c.18-.14.45,0,.65.11Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.63,358.87a9.68,9.68,0,0,0,1.23.76,3.71,3.71,0,0,0,1.36.28,18.93,18.93,0,0,0,3.28.08c2.74-.13,5.47-.55,8.21-.79,5.63-.5,12-2.32,15.79-.9s7.25,6,1.94,11.61a26,26,0,0,1-7.1,5.39c-6.29,2.63-12.82,2.14-17,3.06-5.4,1.19-8.4,3.5-13.38,3.95-6.45.59-10.47-1.16-11.54-2.91-.6-1,.06-6-.74-9.95-.7-3.38-.52-5.68.7-5.53a6.07,6.07,0,0,0,.94,1.2,4.51,4.51,0,0,0,1.43,1.13,11.48,11.48,0,0,0,2.42.81,14.5,14.5,0,0,0,4.49.62,2.13,2.13,0,0,0,1.22-.39,2.57,2.57,0,0,0,.71-1.52c.1-.5.21-1,.31-1.5a2.17,2.17,0,0,1,.28-.77,2.06,2.06,0,0,1,.76-.61A6.56,6.56,0,0,0,261.4,361a5.72,5.72,0,0,0,.72-2.32.55.55,0,0,1,.16-.38c.18-.14.45,0,.65.11Z",
    transform: "translate(-25.13 -24.88)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M281.2,366.83s-.46-5.86-4.74-7.51a2.27,2.27,0,0,0-2.39.25s4,.68,5.14,7.57c0,0,.2.46,1.08.32C280.58,367.42,281.23,367.32,281.2,366.83Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#fafafa"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M270.38,359.94s0-.2,1-.36a1.78,1.78,0,0,1,1.18.16s3.19,1.47,3.64,7.6c0,0,0,.73-1,.91a.89.89,0,0,1-1.12-.57s0,0,0-.06S273.57,361.18,270.38,359.94Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#fafafa"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M266.92,360s.19-.36.95-.34c.95,0,1.16.4,1.16.4s2.24,2.41,2.14,7.51c0,0,.08.87-1.13.93s-1-.91-1-.91S268.78,361.05,266.92,360Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#fafafa"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M243.84,287.59c3.86,11.87,13.72,45.66,18.22,63,0,0-8.09,7.28-18.5,6.64l-25.09-65.06,10-6.18Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#455a64"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M161.23,450a1.63,1.63,0,0,0,1.63-1.63h0V343.81a1.63,1.63,0,0,0-3.26,0V448.4A1.63,1.63,0,0,0,161.23,450Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#455a64"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M96.52,412A1.61,1.61,0,0,0,98,411l32.07-81.18a1.62,1.62,0,1,0-2.89-1.46,1.53,1.53,0,0,0-.11.27L95,409.73A1.73,1.73,0,0,0,96.52,412Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#455a64"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M100.37,402.21a1.6,1.6,0,0,0,1.18-.51l59.68-63.15,59.57,62.88a1.63,1.63,0,0,0,2.36-2.24l-60.75-64.13a1.64,1.64,0,0,0-1.18-.51h0a1.64,1.64,0,0,0-1.18.51l-60.86,64.4a1.63,1.63,0,0,0,1.18,2.75Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#455a64"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M225.94,412a1.53,1.53,0,0,0,.6-.12,1.63,1.63,0,0,0,.91-2.11L195.38,328.6a1.63,1.63,0,0,0-3.17.76,1.61,1.61,0,0,0,.17.43L224.46,411A1.62,1.62,0,0,0,225.94,412Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#455a64"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M226.72,307.94c1.17-6.56-4.17-11.68-14.23-18.47a239.18,239.18,0,0,0-29.13-16.37c-8.42-3.86-17-3.5-27.79,2-15,7.69-60,35-60,35s67.32,38,80.27,36.3,45.32-22.76,47.89-30.17S226.72,307.94,226.72,307.94Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.72,307.94c1.17-6.56-4.17-11.68-14.23-18.47a239.18,239.18,0,0,0-29.13-16.37c-8.42-3.86-17-3.5-27.79,2-15,7.69-60,35-60,35s67.32,38,80.27,36.3,45.32-22.76,47.89-30.17S226.72,307.94,226.72,307.94Z",
    transform: "translate(-25.13 -24.88)"
  }))), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M169.35,338.43c9.66,8.75,19.76,1.22,35.74-9.15,18.09-11.73,21.63-21.34,21.63-21.34s0,7.2-1.35,10.57-4.27,7.2-17.31,16.19-22.49,13.49-31.26,15.16l-6.92-.95",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.09,329.28c18.09-11.73,21.63-21.34,21.63-21.34s0,7.2-1.35,10.57-4.27,7.2-17.31,16.19-22.49,13.49-31.26,15.16l-6.92-.95-.53-10.48C179,347.18,189.11,339.65,205.09,329.28Z",
    transform: "translate(-25.13 -24.88)",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M99,399.22l-5,11.42a1.59,1.59,0,0,0-.06.3.74.74,0,0,0,0,.21,1.43,1.43,0,0,0,.63.76,3,3,0,0,0,2.68.13,1.18,1.18,0,0,0,.55-.53h0v-.15l4.6-10.71Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M223.73,399.7,228,410.89a1.41,1.41,0,0,1,0,.29v.2a1.33,1.33,0,0,1-.64.7,2.8,2.8,0,0,1-2.58,0,1.17,1.17,0,0,1-.51-.52h0v-.16l-3.93-10.49Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M159.35,440.3v9.26a1,1,0,0,0,.55.76,2.9,2.9,0,0,0,2.66,0,.94.94,0,0,0,.54-.76V440.3A4,4,0,0,0,159.35,440.3Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M122.54,268.72c3.83,4.47,38.72-5.57,48-6.83,14.9-2,27-3.51,32.1-1.92s7.21,4.17,8.76,10.23c1.83,7.14,2.77,10.79,2.77,10.79s-24.76,9.5-44.3,11.79S122.54,268.72,122.54,268.72Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#37474f"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M116,275.27c-3.87,14.74-7.34,31.88,1.61,41.26,6,6.32,36.31,22.74,55.85,16.27,19.24-6.37,59.1-36,63.1-38.93s7.63-5,7.25-6.28c-5.37-17.84-13.23-19.24-27.79-16-17.82,3.92-56.92,19.87-56.92,19.87Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#455a64"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "179.39 155.64 165.95 170.83 144.25 160.53 159.42 139.54 179.39 155.64",
    fill: "#ffa8a7"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M221.19,151.66s5.5,7.94,4.91,8.75-4.48,1.61-4.48,1.61Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#f28f8f"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M221.15,156.91a6.58,6.58,0,1,1,6.58-6.58A6.59,6.59,0,0,1,221.15,156.91Zm0-11.95a5.37,5.37,0,1,0,5.37,5.37h0a5.38,5.38,0,0,0-5.37-5.33Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#263238"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M205.92,129.68c10.81,2,14,6.68,15.43,23.75,1.46,17.83-.23,23.49-2.52,25.94-1.55,1.66-10.34,2.16-14.81,1-5.59-1.41-18.25-5.57-24.33-14.42-7.16-10.41-9.31-24.69-2-30.73C187.89,126.75,201.52,128.86,205.92,129.68Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#ffa8a7"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M204.52,180.52c4.65,1,11.73.41,13.83-.79a16.1,16.1,0,0,1-7.83-.29,25.7,25.7,0,0,1-7.17-3.16Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#f28f8f"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M223.35,136.67h0c-3,2.08-6.7,2.94-10.32,3.51.28,2.89-.63,5.75-1.53,8.52-.62,1.91-2.87,7.92-5.32,4.62-1.77-2.38-3.37-4.55-6.76-4-5.58,1-6.17,8.11-2.54,12.37s6.88,2.52,6.88,2.52.51,7.69-3.55,13.13c0,0-6.05,3.72-14.55.92-5.36-1.77-13.1-8.53-15.95-13.81-7.85-14.52-7.89-28.44,1.63-32.72.88-7,6.27-10.2,12.46-11.77,8.59-2.18,17.51,3.21,25.81-.35,1.75-.75,3.36-1.81,5.15-2.46a3.56,3.56,0,0,1,3.09,0,3.76,3.76,0,0,1,1.32,2.36,6.62,6.62,0,0,1-.33,5,15.19,15.19,0,0,1,3.91-1.44,4.91,4.91,0,0,1,3.94.89,5.06,5.06,0,0,1,1.58,3.44C228.58,131.07,226.35,134.58,223.35,136.67Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#263238"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M171.19,134.12l-6.52-3.65a3.74,3.74,0,1,1,6.69,3.35C171.31,133.92,171.25,134,171.19,134.12Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#263238"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 205.97,
    y: 150.89,
    width: 21.26,
    height: 1.03,
    transform: "translate(-49.23 17.42) rotate(-10.57)",
    fill: "#263238"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M249.86,189.4c-.56-.94-1.81-1.13-2.85-1.49-1.92-.67-3.42-2.2-5.27-3a10.36,10.36,0,0,0-6.66-.45,16.88,16.88,0,0,0-2.22.71,28.71,28.71,0,0,0-4,2c-5.3,3.13-9.28,10.22-14.49,13.47-1.94,1.21-3.75,2.31-5.54,3.41l12.47,11a73.5,73.5,0,0,1,6.14-4.67c3.06-1.82,6.15-1.86,9.59-2.36a48.41,48.41,0,0,0,7-1.75A3.07,3.07,0,0,0,246.1,205a2.08,2.08,0,0,0-1.34-2.56,17.82,17.82,0,0,0-3.63-.5c-.9-.14-3.3.39-3.83-.51-.28-.48.07-1.06.41-1.49,2.16-2.69,4.89-5.57,8.34-6.38a7.29,7.29,0,0,0,3-1.21A2.39,2.39,0,0,0,249.86,189.4Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#ffa8a7"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M175.47,177c-13.21-7.21-25.24-2.58-29.57,6.69-3.93,8.39-12.17,40.85-12.17,40.85C137.69,232,175.47,177,175.47,177Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M173.49,179.6l2-2.61c-14.92-7.08-28.27,2.22-40,20.52-12.68,19.72-19.33,48-19.39,77.91,0,0,2.53,13.43,19.49,20.14,18,7.13,43.11,4.11,50.94-14.55,0,0,.16-18.63,5.82-27.81,3.67-5.94,12.22-19.13,18.58-28.6,5.54-8.24,9.85-27-1.72-33.85a97.92,97.92,0,0,0-9.41-4.8C189.22,189.43,172.13,183.78,173.49,179.6Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.53,179.67l1.94-2.68c-14.92-7.08-28.27,2.22-40,20.52-12.68,19.72-19.33,48-19.39,77.91,0,0,2.53,13.43,19.49,20.14,18,7.13,43.11,4.11,50.94-14.55,0,0,.16-18.63,5.82-27.81,3.67-5.94,12.22-19.13,18.58-28.6,5.54-8.24,9.85-27-1.72-33.85a97.92,97.92,0,0,0-9.41-4.8C189.22,189.43,172.17,183.85,173.53,179.67Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#fff",
    opacity: 0.75,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.7,212.65a30.28,30.28,0,0,0,.46-10.86h0A58,58,0,0,1,204.9,219c-6.07,6.39-13.56,11.37-19.19,18.15-6,7.18-10.25,15.87-15.25,23.71-2,3.15-4.74,9.22-8.46,9.47-4.54.29-8.88-5.24-11.35-9.06-4-6.08-7.34-13.69-12.25-19-4.29-4.67-10.93-10.65-16.77-7.94h0c-.44,1.55-.85,3.12-1.24,4.7s-.75,3.22-1.09,4.83v.19c-.33,1.62-.64,3.25-.93,4.88a1.13,1.13,0,0,1,0,.26q-.42,2.43-.75,4.86a158.06,158.06,0,0,0-1.49,21.41s2.53,13.43,19.49,20.14c18,7.13,43.11,4.11,50.94-14.55,0,0,.16-18.63,5.82-27.81.57-.92,1.27-2,2-3.27h0l.13-.21c.65-1,1.35-2.13,2.11-3.31,0-.07.09-.14.14-.21v-.09c1.62-2.53,3.44-5.33,5.32-8.22l.85-1.31c1.82-2.78,3.67-5.59,5.43-8.24h0c.59-.89,1.17-1.76,1.75-2.61.24-.37.49-.73.72-1.09h0c.2-.29.4-.61.59-.93l.18-.3.42-.74.18-.34.45-.88a1.63,1.63,0,0,1,.11-.23c.19-.39.37-.79.55-1.2v-.12c.16-.38.32-.76.47-1.14a.94.94,0,0,1,.1-.28c.14-.37.28-.74.41-1.11v-.22c.24-.69.46-1.41.66-2.13h0c.2-.73.38-1.47.54-2.21v-.09Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M284.89,230.8a27.57,27.57,0,0,1-3.1,3.2c-4.56,4.13-9.89,6.12-16.09,10.14-5,3.25-12.73,8-19.24,12.05a97.27,97.27,0,0,1-21,9.68c-6,1.78-9.43,1.85-13-7.83-1.75-4.75-3.14-9.63-4.66-14.46q-3.37-10.79-6.64-21.61c-3.27-10.82-8-19.83,10-29.79,7.83,4.48,10.81,6.29,13.27,15.67,2.94,11.23,7.7,33.39,7.7,33.39a156.74,156.74,0,0,0,18.59-7.92c2.28-1.13,5.09-1.92,6.72-3.95a30.18,30.18,0,0,0,2.86-4.46c.77-1.38,1.32-2.88,2.17-4.2a37.29,37.29,0,0,1,5.91-6.51,2.46,2.46,0,0,1,1.43-.85,1.67,1.67,0,0,1,1.45.88c.66,1.16.05,2.29-.29,3.47-.39,1.35-.78,2.7-1.16,4A35.25,35.25,0,0,0,281.28,211a5.52,5.52,0,0,1,.9-1.14,1.72,1.72,0,0,1,1.34-.49c1.2.15,2.39,2.09,2.45,3.2a17.45,17.45,0,0,0,.09,3.39c.27,1,1,1.9,1.31,2.92a17.13,17.13,0,0,1,.68,3.24,11.12,11.12,0,0,1-1.82,6.79A16.57,16.57,0,0,1,284.89,230.8Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#ffa8a7"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M210.08,191.35c6.85,2.77,11.79,5.9,14.91,16.36S231.51,235,231.51,235s.06,3.51-8.26,8.42a20.5,20.5,0,0,1-16.11,2.17l-6.28-20.2S189.72,198.33,210.08,191.35Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M169.88,348.91c-5.5-.28-9.81-4.32-22.89-9.77C122.83,329.07,104.71,321,97.8,308.36s-11.79-49.18-10.06-65a20.52,20.52,0,0,1,1.18-5.24l-1.7-.25,4.4-3.75h0c4.52-3.68,11.86-.4,17.4,2.62,15.82,8.6,28.19,17,38,47.17,7.35,22.71,12.2,43.43,22.36,54.51",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.92,238.12l-1.7-.25,4.4-3.75h0c4.52-3.68,11.86-.4,17.4,2.62,15.82,8.6,28.19,17,38,47.17,7.35,22.71,12.2,43.43,22.36,54.51l.53,10.48c-5.5-.28-9.81-4.32-22.89-9.77C122.83,329.07,104.71,321,97.8,308.36s-11.79-49.18-10.06-65A20.52,20.52,0,0,1,88.92,238.12Z",
    transform: "translate(-25.13 -24.88)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M104.44,240.64c15.81,8.6,28.18,17,38,47.17s15.13,56.88,34.4,62.05c0,0-8.71,3.47-35.41-7.83-8.5-3.59-18.81-10.14-25.58-13.94-13.27-7.45-21.32-13.55-22.59-15.84-7-12.59-11.79-49.18-10.07-65S96.51,236.32,104.44,240.64Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-10-2",
    "data-name": "freepik--speech-bubble--inject-10"
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M193.34,106.69,189,98.48l3.51-10.15V82.12l-10.75,6.21v6.21l4.62,8a.59.59,0,0,0,.32.28h0Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.34,106.69,189,98.48l3.51-10.15V82.12l-10.75,6.21v6.21l4.62,8a.59.59,0,0,0,.32.28h0Z",
    transform: "translate(-25.13 -24.88)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M219,32.75a7.11,7.11,0,0,0-3.23-5.59l-2.62-1.51a7.12,7.12,0,0,0-6.45,0L166.45,48.94a7.13,7.13,0,0,0-3.22,5.59V98.84a7.11,7.11,0,0,0,3.22,5.58l2.63,1.52a7.12,7.12,0,0,0,6.45,0l12.95-7.48,4.62,8a.68.68,0,0,0,.93.26.69.69,0,0,0,.31-.38l4.88-14.08,16.58-9.6a7.12,7.12,0,0,0,3.2-5.6Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#353232"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.23,98.84a7.11,7.11,0,0,0,3.22,5.58l2.63,1.52a7.19,7.19,0,0,0,5.9.26c-1.52.57-2.68-.28-2.68-2.12V59.77a6.62,6.62,0,0,1,.95-3.18l-9.08-5.24a6.61,6.61,0,0,0-.94,3.18Z",
    transform: "translate(-25.13 -24.88)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.92,31.83c-.37-1.37-1.62-1.8-3.11-.95l-40.28,23.3a6.33,6.33,0,0,0-2.27,2.41l-9.08-5.24a6.53,6.53,0,0,1,2.27-2.4l40.27-23.3a7.12,7.12,0,0,1,6.45,0l2.64,1.52A7.1,7.1,0,0,1,218.92,31.83Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.23,77.16a2.41,2.41,0,0,1,.16-.92,7.17,7.17,0,0,1,.47-.86l8.76-14.15a.75.75,0,0,1,.14-.17l.1-.07a.24.24,0,0,1,.32,0,.6.6,0,0,1,.14.43v5.46a2.36,2.36,0,0,1-.26,1.14,7,7,0,0,1-.44.75l-4.52,6.88,4.52,2.08a1.78,1.78,0,0,1,.44.21c.17.11.26.39.26.83v3.88a1.3,1.3,0,0,1-.14.58.83.83,0,0,1-.32.4h-.1a.33.33,0,0,1-.14,0l-8.76-4a1.27,1.27,0,0,1-.47-.32,1.17,1.17,0,0,1-.16-.73Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.31,55.3a6.63,6.63,0,0,1,.33-.88,1.58,1.58,0,0,1,.64-.69L201.21,52a.27.27,0,0,1,.34,0,.63.63,0,0,1,.14.44,1.82,1.82,0,0,1,0,.33l-7.4,31.54a4.33,4.33,0,0,1-.31.85,1.6,1.6,0,0,1-.65.71l-2.87,1.66a.27.27,0,0,1-.34,0,.55.55,0,0,1-.14-.44,1.71,1.71,0,0,1,0-.32Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.4,60.4a2.23,2.23,0,0,1-.16.92,7.17,7.17,0,0,1-.47.86L204,76.34a1.07,1.07,0,0,1-.14.16l-.1.08a.26.26,0,0,1-.33,0,.56.56,0,0,1-.13-.43V70.67a2.19,2.19,0,0,1,.25-1.12c.17-.3.32-.54.45-.73l3.83-5.92L204,61.44a1.6,1.6,0,0,1-.45-.23c-.17-.12-.25-.4-.25-.85V54.9a1.29,1.29,0,0,1,.13-.58,1,1,0,0,1,.33-.39H204l8.76,4a.87.87,0,0,1,.63,1Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#fff"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-boxes--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-10-2",
    "data-name": "freepik----inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-10-3",
    "data-name": "freepik--speech-bubble--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.5,27.2,42.61,58.25a2.94,2.94,0,0,0-1.34,2.31V90.65A2.92,2.92,0,0,0,42.61,93l5.32,3a3,3,0,0,0,2.68,0L104.5,65a3,3,0,0,0,1.34-2.32V32.52a2.9,2.9,0,0,0-1.34-2.3l-5.32-3A3,3,0,0,0,96.5,27.2Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.82,32.28c-.1-.68-.65-.92-1.32-.54L50.62,62.79a2.76,2.76,0,0,0-.95,1l-8-4.59a2.6,2.6,0,0,1,.92-1l53.89-31a3,3,0,0,1,2.68,0l5.32,3A3,3,0,0,1,105.82,32.28Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5,31.75l-53.89,31a3,3,0,0,0-1.33,2.32V95.19c0,.85.6,1.2,1.33.77L104.5,65a3,3,0,0,0,1.34-2.32V32.52C105.84,31.67,105.24,31.32,104.5,31.75Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#37474f"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M62.6,70.5V75a5.29,5.29,0,0,0,.15,1,1.71,1.71,0,0,0,.38.76,1,1,0,0,0,.65.3,1.88,1.88,0,0,0,1-.32,3.93,3.93,0,0,0,1-.77,4.61,4.61,0,0,0,1-1.76c.08-.3.15-.56.19-.8a3.55,3.55,0,0,1,.19-.71,1,1,0,0,1,.4-.4L69.75,71A.2.2,0,0,1,70,71a.49.49,0,0,1,.11.35,10.54,10.54,0,0,1-.43,2.79,12.7,12.7,0,0,1-1.13,2.72,13.67,13.67,0,0,1-1.7,2.37A8.72,8.72,0,0,1,64.76,81a4.45,4.45,0,0,1-2.21.71,2.5,2.5,0,0,1-1.66-.59,3.63,3.63,0,0,1-1.06-1.68,9.44,9.44,0,0,1-.42-2.53V72.2a13.81,13.81,0,0,1,.41-3,15,15,0,0,1,1.06-2.9,12.7,12.7,0,0,1,1.66-2.51,8.59,8.59,0,0,1,2.22-1.85,4.68,4.68,0,0,1,2.11-.7,2.82,2.82,0,0,1,1.7.41,3,3,0,0,1,1.13,1.41,5.82,5.82,0,0,1,.43,2.29,1.13,1.13,0,0,1-.11.48.67.67,0,0,1-.27.33l-2.25,1.3c-.2.11-.33.13-.4.05a1.18,1.18,0,0,1-.19-.48,3.93,3.93,0,0,0-.19-.58,1.18,1.18,0,0,0-.37-.46,1.13,1.13,0,0,0-.62-.16,2.11,2.11,0,0,0-1,.35,3.56,3.56,0,0,0-1,.81,4.79,4.79,0,0,0-.65,1.06,5.59,5.59,0,0,0-.38,1.2A8.66,8.66,0,0,0,62.6,70.5Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.24,54.73a4.49,4.49,0,0,1,2-.67,2.85,2.85,0,0,1,1.59.34,2.57,2.57,0,0,1,1,1.09A3.49,3.49,0,0,1,82.3,57a1.13,1.13,0,0,1-.11.48.69.69,0,0,1-.25.31L79.68,59.1a.6.6,0,0,1-.39.11.69.69,0,0,1-.3-.14l-.16-.17a.83.83,0,0,0-.32-.2,1.14,1.14,0,0,0-.52,0,2.21,2.21,0,0,0-.75.29,5.39,5.39,0,0,0-.63.43,4.34,4.34,0,0,0-.53.52,2.52,2.52,0,0,0-.38.63,1.93,1.93,0,0,0-.15.75.79.79,0,0,0,.17.57.73.73,0,0,0,.55.17,4.26,4.26,0,0,0,1-.16l1.58-.41a5.13,5.13,0,0,1,1.65-.21,1.9,1.9,0,0,1,1.18.45,2.44,2.44,0,0,1,.71,1.18,7.49,7.49,0,0,1,.23,2,9.12,9.12,0,0,1-.39,2.64A11,11,0,0,1,81.14,70a10.79,10.79,0,0,1-1.69,2.12,10.56,10.56,0,0,1-2.13,1.63,5.23,5.23,0,0,1-2.13.75,2.81,2.81,0,0,1-1.66-.3,2.53,2.53,0,0,1-1.09-1.13A3.86,3.86,0,0,1,72,71.34a1,1,0,0,1,.12-.48.66.66,0,0,1,.25-.32l2.25-1.3a.64.64,0,0,1,.38-.12.55.55,0,0,1,.27.12l.21.22a1.13,1.13,0,0,0,.37.28,1.15,1.15,0,0,0,.58.1,2.08,2.08,0,0,0,.87-.32,6.26,6.26,0,0,0,1.53-1.18,2.15,2.15,0,0,0,.61-1.46.55.55,0,0,0-.23-.53,1.19,1.19,0,0,0-.67-.1,6.21,6.21,0,0,0-1.14.22c-.47.13-1,.27-1.64.42a2.48,2.48,0,0,1-2.59-.45,4.69,4.69,0,0,1-.82-3.17,9.48,9.48,0,0,1,.33-2.37,11.1,11.1,0,0,1,1-2.39,10.21,10.21,0,0,1,1.54-2.14A8.6,8.6,0,0,1,77.24,54.73Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7,47.54a4.58,4.58,0,0,1,2-.68,2.94,2.94,0,0,1,1.59.34,2.63,2.63,0,0,1,1,1.09,3.5,3.5,0,0,1,.4,1.55,1,1,0,0,1-.12.48.59.59,0,0,1-.25.31l-2.25,1.3a.67.67,0,0,1-.39.12.69.69,0,0,1-.3-.14l-.16-.17a.83.83,0,0,0-.32-.2,1.14,1.14,0,0,0-.52,0,1.86,1.86,0,0,0-.75.29,5.39,5.39,0,0,0-.63.43,3.8,3.8,0,0,0-.54.52,2.48,2.48,0,0,0-.37.63,1.93,1.93,0,0,0-.15.75.8.8,0,0,0,.16.56.74.74,0,0,0,.55.18,4.26,4.26,0,0,0,1-.16l1.58-.41A5.07,5.07,0,0,1,93,54.07a2,2,0,0,1,1.18.44,2.43,2.43,0,0,1,.71,1.19,7.49,7.49,0,0,1,.23,2,8.71,8.71,0,0,1-.4,2.64,11,11,0,0,1-2.79,4.58,10.56,10.56,0,0,1-2.13,1.63,5.23,5.23,0,0,1-2.13.75A3,3,0,0,1,86,67a2.59,2.59,0,0,1-1.09-1.13,3.79,3.79,0,0,1-.42-1.75,1,1,0,0,1,.12-.47.64.64,0,0,1,.24-.32L87.11,62a.82.82,0,0,1,.38-.13.55.55,0,0,1,.27.12l.21.23a1,1,0,0,0,.37.27,1,1,0,0,0,.58.1,1.94,1.94,0,0,0,.87-.31,6.56,6.56,0,0,0,1.53-1.19,2.14,2.14,0,0,0,.61-1.45.55.55,0,0,0-.23-.53A1.11,1.11,0,0,0,91,59a5.47,5.47,0,0,0-1.14.22q-.7.2-1.65.42a2.5,2.5,0,0,1-2.59-.45,4.81,4.81,0,0,1-.81-3.17,9.48,9.48,0,0,1,.33-2.37,11.1,11.1,0,0,1,1-2.39,10.54,10.54,0,0,1,1.54-2.15A8.58,8.58,0,0,1,89.7,47.54Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-10-2",
    "data-name": "freepik--text-box--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-10-3",
    "data-name": "freepik----inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-10-4",
    "data-name": "freepik--speech-bubble--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-10-2",
    "data-name": "freepik--speach-bubble--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.5,89.72l-53.89,31A3,3,0,0,0,41.27,123v30.08a2.92,2.92,0,0,0,1.34,2.3l5.32,3a3,3,0,0,0,2.68,0l53.89-31a3,3,0,0,0,1.34-2.32V95a2.92,2.92,0,0,0-1.34-2.3l-5.32-3A3,3,0,0,0,96.5,89.72Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.82,94.79c-.1-.67-.65-.91-1.32-.53l-53.88,31a2.76,2.76,0,0,0-.95,1l-8-4.59a2.62,2.62,0,0,1,.92-1l53.89-31a3,3,0,0,1,2.68,0l5.32,3A2.94,2.94,0,0,1,105.82,94.79Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5,94.26l-53.89,31a3,3,0,0,0-1.33,2.32V157.7c0,.85.6,1.2,1.33.77l53.89-31a3,3,0,0,0,1.34-2.32V95C105.84,94.18,105.24,93.83,104.5,94.26Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#37474f"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M62.85,125.82a.26.26,0,0,1,.33,0,.6.6,0,0,1,.14.43v17.11a1.3,1.3,0,0,1-.14.58.77.77,0,0,1-.33.4l-2.25,1.3a.24.24,0,0,1-.33,0,.6.6,0,0,1-.14-.42v-6.49l-3.82,2.2v6.49a1.34,1.34,0,0,1-.13.59,1,1,0,0,1-.33.4l-2.25,1.3a.26.26,0,0,1-.33,0,.55.55,0,0,1-.14-.44V132.15a1.35,1.35,0,0,1,.14-.59.92.92,0,0,1,.33-.4l2.25-1.3a.26.26,0,0,1,.33,0,.54.54,0,0,1,.13.42v6.38l3.82-2.2V128.1a1.3,1.3,0,0,1,.14-.58.92.92,0,0,1,.33-.4Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.43,118.56a.24.24,0,0,1,.33,0,.6.6,0,0,1,.14.42v2.81a1.3,1.3,0,0,1-.14.58.89.89,0,0,1-.33.41l-3,1.74v13.59a1.34,1.34,0,0,1-.13.59,1,1,0,0,1-.33.4l-2.25,1.3a.26.26,0,0,1-.33,0,.6.6,0,0,1-.14-.43V126.38l-3,1.75a.26.26,0,0,1-.33,0,.57.57,0,0,1-.13-.43v-2.8a1.34,1.34,0,0,1,.13-.59.92.92,0,0,1,.33-.4Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.34,127.86a1.13,1.13,0,0,1-.24-.3l-1.61-3.44v8.77a1.3,1.3,0,0,1-.14.58.77.77,0,0,1-.33.4l-2.25,1.3a.24.24,0,0,1-.33,0,.6.6,0,0,1-.14-.42V117.61a1.3,1.3,0,0,1,.14-.58.92.92,0,0,1,.33-.4l2-1.15c.22-.14.4-.14.51,0a1.7,1.7,0,0,1,.23.3l2.78,5.72,2.79-8.94a5.42,5.42,0,0,1,.22-.56,1.3,1.3,0,0,1,.52-.59l2-1.15a.24.24,0,0,1,.32,0,.6.6,0,0,1,.14.43V127.8a1.35,1.35,0,0,1-.14.59,1,1,0,0,1-.32.4l-2.26,1.3a.26.26,0,0,1-.33,0,.54.54,0,0,1-.13-.42V120.9l-1.62,5.31c-.07.19-.14.38-.23.57a1,1,0,0,1-.41.46l-1.1.63C83.57,128,83.44,128,83.34,127.86Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,117.53a.26.26,0,0,1,.33,0,.58.58,0,0,1,.14.42v2.81a1.3,1.3,0,0,1-.14.58.77.77,0,0,1-.33.4l-8,4.6a.26.26,0,0,1-.33,0,.6.6,0,0,1-.14-.42V108.81a1.3,1.3,0,0,1,.14-.58.77.77,0,0,1,.33-.4l2.25-1.3a.24.24,0,0,1,.33,0,.59.59,0,0,1,.13.42v13.59Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-10-3",
    "data-name": "freepik--text-box--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-10-4",
    "data-name": "freepik----inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-10-5",
    "data-name": "freepik--speech-bubble--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-10-3",
    "data-name": "freepik--speach-bubble--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.5,152.23,42.61,183.28a2.94,2.94,0,0,0-1.34,2.31v30.08a2.9,2.9,0,0,0,1.34,2.3l5.32,3a3,3,0,0,0,2.68,0l53.89-31.05a2.94,2.94,0,0,0,1.34-2.31V157.55a2.94,2.94,0,0,0-1.34-2.31l-5.32-3A3,3,0,0,0,96.5,152.23Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.82,157.3c-.1-.67-.65-.91-1.32-.53l-53.88,31a2.68,2.68,0,0,0-.95,1l-8-4.59a2.6,2.6,0,0,1,.92-1l53.89-31a3,3,0,0,1,2.68,0l5.32,3A3,3,0,0,1,105.82,157.3Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5,156.77l-53.89,31a3,3,0,0,0-1.33,2.31v30.08c0,.86.6,1.2,1.33.78l53.89-31.05a2.94,2.94,0,0,0,1.34-2.31v-30C105.84,156.69,105.24,156.35,104.5,156.77Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#37474f"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M63.64,194.92v4.53a6.54,6.54,0,0,0,.16,1.08,1.71,1.71,0,0,0,.38.76,1,1,0,0,0,.65.3,1.88,1.88,0,0,0,1-.32,4.13,4.13,0,0,0,1-.76,5.37,5.37,0,0,0,.62-.88,4.64,4.64,0,0,0,.37-.89,7.16,7.16,0,0,0,.19-.8,3.55,3.55,0,0,1,.19-.71,1,1,0,0,1,.4-.4l2.25-1.3a.2.2,0,0,1,.27,0,.49.49,0,0,1,.11.35,10.54,10.54,0,0,1-.43,2.79,12.24,12.24,0,0,1-1.14,2.72A12.76,12.76,0,0,1,68,203.76a8.55,8.55,0,0,1-2.11,1.73,4.35,4.35,0,0,1-2.21.71,2.5,2.5,0,0,1-1.66-.59,3.63,3.63,0,0,1-1.06-1.68,9.44,9.44,0,0,1-.42-2.53v-4.71a13.81,13.81,0,0,1,.41-3,15,15,0,0,1,1.06-2.9,12.7,12.7,0,0,1,1.66-2.51,8.79,8.79,0,0,1,2.22-1.85,4.68,4.68,0,0,1,2.11-.7,2.88,2.88,0,0,1,1.69.41,3,3,0,0,1,1.14,1.41,5.84,5.84,0,0,1,.43,2.3,1.12,1.12,0,0,1-.11.47.67.67,0,0,1-.27.33L68.6,192c-.2.11-.33.13-.4.06a1.28,1.28,0,0,1-.19-.49,3.93,3.93,0,0,0-.19-.58,1.18,1.18,0,0,0-.37-.46,1.13,1.13,0,0,0-.62-.16,2.11,2.11,0,0,0-1,.35,3.56,3.56,0,0,0-1,.81,4.79,4.79,0,0,0-.65,1.06,5.59,5.59,0,0,0-.38,1.2A9.3,9.3,0,0,0,63.64,194.92Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.44,191.39v4.37a1.35,1.35,0,0,1-.14.59,1,1,0,0,1-.32.4L76.81,198a.26.26,0,0,1-.33,0,.6.6,0,0,1-.14-.43V193.2l-2.66,1.54a.26.26,0,0,1-.33,0,.6.6,0,0,1-.14-.43V191.6a1.3,1.3,0,0,1,.14-.58.89.89,0,0,1,.33-.41l2.66-1.54V184.7a1.3,1.3,0,0,1,.14-.58.92.92,0,0,1,.33-.4L79,182.47a.24.24,0,0,1,.32,0,.6.6,0,0,1,.14.42v4.38l2.65-1.53a.24.24,0,0,1,.33,0,.6.6,0,0,1,.14.42v2.68a1.3,1.3,0,0,1-.14.58.77.77,0,0,1-.33.4Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.85,184.81v4.37a1.3,1.3,0,0,1-.14.58.92.92,0,0,1-.33.4l-2.16,1.25a.26.26,0,0,1-.33,0,.6.6,0,0,1-.14-.42v-4.38l-2.67,1.54a.22.22,0,0,1-.32,0,.6.6,0,0,1-.14-.42V185a1.3,1.3,0,0,1,.14-.58.83.83,0,0,1,.32-.4l2.67-1.54v-4.37a1.35,1.35,0,0,1,.14-.59.92.92,0,0,1,.33-.4l2.16-1.25a.26.26,0,0,1,.33,0,.6.6,0,0,1,.14.43v4.37l2.65-1.53a.26.26,0,0,1,.33,0,.57.57,0,0,1,.13.43v2.67a1.29,1.29,0,0,1-.13.58.92.92,0,0,1-.33.4Z",
    transform: "translate(-25.13 -24.88)",
    fill: "#f0f0f0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDc21);
export default __webpack_public_path__ + "static/media/dc2_1.8c88a68f4b3d2a2b94ce54b2c0233272.svg";
export { ForwardRef as ReactComponent };